// 10NewCase.js의 formData key 목록 기반
// label/type 없이 key만 배열로 작성

export const formFieldKeys = [
  "data_id",
  "case_id",
  "index_injury",
  "index_injury_memo",
  "hos_id",
  "age",
  "sex",
  "ht",
  "wt",
  "hospital",
  "last_normal_dt",
  "symptom_onset_dt",
  "arrival_dt",
  "arrival_from",
  "arrival_airway",
  "arrival_breathing",
  "arrival_circulation",
  "arrival_sbp",
  "arrival_dbp",
  "arrival_hr",
  "arrival_temp",
  "arrival_rr",
  "arrival_spo2",
  "arrival_rr_unk",
  "arrival_gcs_e",
  "arrival_gcs_v",
  "arrival_gcs_m",
  "arrival_gcs_score",
  "arrival_gcs_confounder",
  "arrival_pupil_size_rt",
  "arrival_pupil_size_lt",
  "arrival_pupil_react_rt",
  "arrival_pupil_react_lt",
  "arrival_pupillometer_yn",
  "arrival_image",
  "arrival_image_dt",
  "hx_htn",
  "hx_dm",
  "hx_cirrhosis",
  "hx_stroke",
  "hx_malignancy",
  "hx_ckd",
  "hx_plt",
  "hx_plt_type",
  "hx_coa",
  "hx_coa_type",
  "hx_alcohol",
  "hx_smok",
  "hx_smok_pyrs",
  "hx_pre_mrs",
  "sah_wfns",
  "sah_modified_fisher",
  "sah_hh",
  "sah_aneurysmal",
  "sah_others",
  "sah_ich",
  "sah_ich_location",
  "sah_ich_location_other",
  "sah_ich_volume",
  "aneurysm_location",
  "aneurysm_location_other",
  "aneurysm_height",
  "aneurysm_width",
  "aneurysm_diameter",
  "aneurysm_neck_max",
  "aneurysm_shape_pathology",
  "aneurysm_laterality",
  "aneurysm_aspect_ratio",
  "aneurysm_morphology_type",
  "aneurysm_bottleneck_factor",
  "aneurysm_unruptured_number",
  "sah_aneurysm_surg",
  "sah_aneurysm_surg_type",
  "sah_aneurysm_surg_other",
  "sah_aneurysm_surg_start_dt",
  "sah_aneurysm_surg_end_dt",
  "sah_aneurysm_surg_comp",
  "sah_aneurysm_surg_comp_other",
  "sah_aneurysm_endo",
  "sah_aneurysm_endo_type",
  "sah_aneurysm_endo_type_other",
  "sah_aneurysm_endo_start_dt",
  "sah_aneurysm_endo_end_dt",
  "sah_aneurysm_endo_comp",
  "sah_aneurysm_endo_comp_others",
  "sah_csf_diversion",
  "sah_csf_diversion_dt",
  "sah_csf_removal_dt",
  "sah_rebleeding",
  "sah_rebleeding_dt",
  "sah_hcp_acute",
  "tbi_injury_type",
  "tbi_injury_type_others",
  "tbi_iss_headneck",
  "tbi_iss_face",
  "tbi_iss_chest",
  "tbi_iss_abdomen",
  "tbi_iss_external",
  "tbi_iss_extremities",
  "tbi_iss_score",
  "tbi_edh",
  "tbi_sdh_acute",
  "tbi_sdh_suba_chr",
  "tbi_mix_dense_csf",
  "tbi_sah",
  "tbi_sah_extent",
  "tbi_skull_fx",
  "tbi_midline_shift",
  "tbi_midline_shift_mm",
  "tbi_cistern_comp",
  "tbi_fourth_vent_eff",
  "tbi_contusion",
  "tbi_ich",
  "tbi_ivh",
  "tbi_acute_hydro",
  "tbi_dai",
  "tbi_rotterdam",
  "tbi_isc_inf_hie",
  "tbi_isc_inf_hie_extent",
  "tbi_txa",
  "tbi_txa_dt",
  "ich_ivh",
  "ich_location",
  "ich_location_others",
  "ich_location_main",
  "ivh_mgraeb_rt_temp",
  "ivh_mgraeb_rt_temp_exp",
  "ivh_mgraeb_rt_lateral",
  "ivh_mgraeb_rt_lateral_exp",
  "ivh_mgraeb_rt_occip",
  "ivh_mgraeb_rt_occip_exp",
  "ivh_mgraeb_lt_temp",
  "ivh_mgraeb_lt_temp_exp",
  "ivh_mgraeb_lt_lateral",
  "ivh_mgraeb_lt_lateral_exp",
  "ivh_mgraeb_lt_occip",
  "ivh_mgraeb_lt_occip_exp",
  "ivh_mgraeb_3rd",
  "ivh_mgraeb_3rd_exp",
  "ivh_mgraeb_4th",
  "ivh_mgraeb_4th_exp",
  "ivh_mgraeb_score",
  "ich_ivh_hydro",
  "ich_volume_abc",
  "ich_ivh_cause",
  "ich_ivh_cause_others",
  "ich_ivh_surgery",
  "ich_ivh_surgery_name",
  "ich_ivh_surgery_others",
  "ich_ivh_surgery_dt",
  "ich_ivh_midline_shift",
  "ich_ivh_midline_shift_mm",
  "ich_ivh_cistern_comp",
  "ich_ivh_fourth_vent_eff",
  "ich_score_gcs",
  "ich_score_ich",
  "ich_score_ivh",
  "ich_score_infratentorial",
  "ich_score_age",
  "ich_score",
  "initial_status",
  "icu_adm_from",
  "icu_adm_dt",
  "icu_adm_gcs_e",
  "icu_adm_gcs_v",
  "icu_adm_gcs_m",
  "icu_adm_gcs_total",
  "icu_adm_gcs_confounder",
  "icp_monitor",
  "icp_device",
  "icp_ins_dt",
  "icp_removal_dt",
  "icp_reason",
  "icp_reason_other",
  "icp_controlled",
  "icp_problems",
  "icp_problems_detail",
  "icp_cath_rev",
  "icp_cath_rev_dt",
  "icp_stop",
  "icp_duration",
  "icp_stop_reason",
  "icp_stop_reason_others",
  "ttm",
  "ttm_start_dt",
  "ttm_end_dt",
  "ttm_duration",
  "dvt_ppx_pharm",
  "dvt_ppx_pharm_start_d",
  "dvt_ppx_pharm_stop_d",
  "dvt_ppx_pharm_ongoing",
  "dvt_ppx_pharm_type",
  "dvt_ppx_mech",
  "dvt_ppx_mech_start_d",
  "dvt_ppx_mech_stop_d",
  "dvt_ppx_mech_type",
  "dvt_ppx_mech_ongoing",
  "nutri_parenteral",
  "nutri_parenteral_start_d",
  "nutri_parenteral_stop_d",
  "nutri_enteral",
  "nutri_enteral_start_d",
  "nutri_enteral_stop_d",
  "nutri_enteral_route",
  "intu",
  "intu_start_dt",
  "intu_stop_dt",
  "intu_stop_reason",
  "reintu",
  "reintu_dt",
  "reintu_reason",
  "mv",
  "mv_start_dt",
  "mv_stop_dt",
  "remv",
  "remv_start_dt",
  "remv_reason",
  "remv_reason_other",
  "trach",
  "trach_reason",
  "trach_start_d",
  "trach_stop_d",
  "trach_ongoing",
  "icu_dis_dt",
  "icu_dis_status",
  "icu_dis_to",
  "icu_dis_gcs_e",
  "icu_dis_gcs_v",
  "icu_dis_gcs_m",
  "icu_dis_gcs_confounder",
  "icu_dis_gcs_total",
  "icu_status",
  "d1_location",
  "d1_gcs_worst_dt",
  "d1_gcs_worst_asscond",
  "d1_gcs_worst_change24h",
  "d1_gcs_worst_change24h_cause",
  "d1_gcs_worst_e",
  "d1_gcs_worst_v",
  "d1_gcs_worst_m",
  "d1_gcs_worst_total",
  "d1_pupil_worst_sym",
  "d1_pupil_worst_lr_lt",
  "d1_pupil_worst_size_lt",
  "d1_pupil_worst_unknown_lt",
  "d1_pupil_worst_lr_rt",
  "d1_pupil_worst_size_rt",
  "d1_pupil_worst_unknown_rt",
  "d1_gcs_best",
  "d1_gcs_best_dt",
  "d1_gcs_best_asscond",
  "d1_gcs_best_change24h",
  "d1_gcs_best_change24h_cause",
  "d1_gcs_best_e",
  "d1_gcs_best_v",
  "d1_gcs_best_m",
  "d1_gcs_best_total",
  "d1_pupil_best_sym",
  "d1_pupil_best_lr_lt",
  "d1_pupil_best_size_lt",
  "d1_pupil_best_unknown_lt",
  "d1_pupil_best_lr_rt",
  "d1_pupil_best_size_rt",
  "d1_pupil_best_unknown_rt",
  "d1_neuroworse",
  "d1_neuroworse_type",
  "d1_neuroworse_action",
  "d1_til_dt",
  "d1_til_complete",
  "d1_til_position",
  "d1_til_position_flat",
  "d1_til_sedation",
  "d1_til_sedation_higher",
  "d1_til_sedation_suppression",
  "d1_til_sedation_nmb",
  "d1_til_csfdrain",
  "d1_til_csfdrainvol",
  "d1_til_fluidloading",
  "d1_til_vasopressor",
  "d1_til_hyperventilation",
  "d1_til_hyperventilation_mod",
  "d1_til_hyperventilation_intense",
  "d1_til_osm_mnt_low",
  "d1_til_osm_hts_low",
  "d1_til_osm_mnt_high",
  "d1_til_osm_hts_high",
  "d1_til_fever",
  "d1_til_ttm_mild",
  "d1_til_ttm_moderate",
  "d1_til_icp_surgery",
  "d1_til_icp_decomcrani",
  "d1_til_change_reason",
  "d1_til_summary",
  "d2_location",
  "d2_gcs_worst_dt",
  "d2_gcs_worst_asscond",
  "d2_gcs_worst_change24h",
  "d2_gcs_worst_change24h_cause",
  "d2_gcs_worst_e",
  "d2_gcs_worst_v",
  "d2_gcs_worst_m",
  "d2_gcs_worst_total",
  "d2_pupil_worst_sym",
  "d2_pupil_worst_lr_lt",
  "d2_pupil_worst_size_lt",
  "d2_pupil_worst_unknown_lt",
  "d2_pupil_worst_lr_rt",
  "d2_pupil_worst_size_rt",
  "d2_pupil_worst_unknown_rt",
  "d2_gcs_best",
  "d2_gcs_best_dt",
  "d2_gcs_best_asscond",
  "d2_gcs_best_change24h",
  "d2_gcs_best_change24h_cause",
  "d2_gcs_best_e",
  "d2_gcs_best_v",
  "d2_gcs_best_m",
  "d2_gcs_best_total",
  "d2_pupil_best_sym",
  "d2_pupil_best_lr_lt",
  "d2_pupil_best_size_lt",
  "d2_pupil_best_unknown_lt",
  "d2_pupil_best_lr_rt",
  "d2_pupil_best_size_rt",
  "d2_pupil_best_unknown_rt",
  "d2_neuroworse",
  "d2_neuroworse_type",
  "d2_neuroworse_action",
  "d2_til_dt",
  "d2_til_complete",
  "d2_til_position",
  "d2_til_position_flat",
  "d2_til_sedation",
  "d2_til_sedation_higher",
  "d2_til_sedation_suppression",
  "d2_til_sedation_nmb",
  "d2_til_csfdrain",
  "d2_til_csfdrainvol",
  "d2_til_fluidloading",
  "d2_til_vasopressor",
  "d2_til_hyperventilation",
  "d2_til_hyperventilation_mod",
  "d2_til_hyperventilation_intense",
  "d2_til_osm_mnt_low",
  "d2_til_osm_hts_low",
  "d2_til_osm_mnt_high",
  "d2_til_osm_hts_high",
  "d2_til_fever",
  "d2_til_ttm_mild",
  "d2_til_ttm_moderate",
  "d2_til_icp_surgery",
  "d2_til_icp_decomcrani",
  "d2_til_change_reason",
  "d2_til_summary",
  "d3_location",
  "d3_gcs_worst_dt",
  "d3_gcs_worst_asscond",
  "d3_gcs_worst_change24h",
  "d3_gcs_worst_change24h_cause",
  "d3_gcs_worst_e",
  "d3_gcs_worst_v",
  "d3_gcs_worst_m",
  "d3_gcs_worst_total",
  "d3_pupil_worst_sym",
  "d3_pupil_worst_lr_lt",
  "d3_pupil_worst_size_lt",
  "d3_pupil_worst_unknown_lt",
  "d3_pupil_worst_lr_rt",
  "d3_pupil_worst_size_rt",
  "d3_pupil_worst_unknown_rt",
  "d3_gcs_best",
  "d3_gcs_best_dt",
  "d3_gcs_best_asscond",
  "d3_gcs_best_change24h",
  "d3_gcs_best_change24h_cause",
  "d3_gcs_best_e",
  "d3_gcs_best_v",
  "d3_gcs_best_m",
  "d3_gcs_best_total",
  "d3_pupil_best_sym",
  "d3_pupil_best_lr_lt",
  "d3_pupil_best_size_lt",
  "d3_pupil_best_unknown_lt",
  "d3_pupil_best_lr_rt",
  "d3_pupil_best_size_rt",
  "d3_pupil_best_unknown_rt",
  "d3_neuroworse",
  "d3_neuroworse_type",
  "d3_neuroworse_action",
  "d3_til_dt",
  "d3_til_complete",
  "d3_til_position",
  "d3_til_position_flat",
  "d3_til_sedation",
  "d3_til_sedation_higher",
  "d3_til_sedation_suppression",
  "d3_til_sedation_nmb",
  "d3_til_csfdrain",
  "d3_til_csfdrainvol",
  "d3_til_fluidloading",
  "d3_til_vasopressor",
  "d3_til_hyperventilation",
  "d3_til_hyperventilation_mod",
  "d3_til_hyperventilation_intense",
  "d3_til_osm_mnt_low",
  "d3_til_osm_hts_low",
  "d3_til_osm_mnt_high",
  "d3_til_osm_hts_high",
  "d3_til_fever",
  "d3_til_ttm_mild",
  "d3_til_ttm_moderate",
  "d3_til_icp_surgery",
  "d3_til_icp_decomcrani",
  "d3_til_change_reason",
  "d3_til_summary",
  "daily_status",
  "what_daily",
  "additional_daily_status",
  "sah_nd1",
  "sah_nd(n)_cause",
  "sah_nd(n)_cause_others",
  "sah_nd(n)_dt",
  "sah_nd2",
  "sah_nd2_cause",
  "sah_nd2_cause_others",
  "sah_nd2_dt",
  "sah_nd3",
  "sah_nd3_cause",
  "sah_nd3_cause_others",
  "sah_nd3_dt",
  "sah_dci",
  "sah_dci_infarct",
  "sah_angio_spasm",
  "sah_angio_spasm_symptom",
  "sah_angio_spasm_degree",
  "sah_angio_spasm_extent",
  "sah_tcd_spasm",
  "sah_tcd_spasm_symptom",
  "sah_tcd_spasm_degree_mfv",
  "sah_tcd_spasm_degree_lr",
  "sah_vasospasm_prophylaxis",
  "sah_induced_htn_tx",
  "sah_rescue_vasopasm_tx",
  "ich_nd1",
  "ich_nd(n)_cause",
  "ich_nd(n)_cause_others",
  "ich_nd(n)_dt",
  "ich_nd2",
  "ich_nd2_cause",
  "ich_nd2_cause_others",
  "ich_nd2_dt",
  "ich_nd3",
  "ich_nd3_cause",
  "ich_nd3_cause_others",
  "ich_nd3_dt",
  "ich_he1",
  "ich_he1_action",
  "ich_he1_dt",
  "ich_he2",
  "ich_he2_action",
  "ich_he2_dt",
  "ich_he3",
  "ich_he3_action",
  "ich_he3_dt",
  "tbi_delayedhematoma",
  "tbi_nd1",
  "tbi_nd(n)_dt",
  "tbi_nd(n)_cause",
  "tbi_nd(n)_cause_others",
  "tbi_nd2",
  "tbi_nd2_dt",
  "tbi_nd2_cause",
  "tbi_nd2_cause_others",
  "tbi_nd3",
  "tbi_nd3_dt",
  "tbi_nd3_cause",
  "tbi_nd3_cause_others",
  "early_outcome_status",
  "dis_status",
  "dis_to",
  "dis_d",
  "braindeath",
  "braindeath_d",
  "braindeath_organ",
  "polst_d",
  "polst",
  "hosp_discharge_status",
  "cranial_surg_completion",
  "cranial_surg_done",
  "extracranial_surg_done",
  "cranial_surg1_start_dt",
  "cranial_surg1_end_dt",
  "cranial_surg1_types",
  "cranial_surg1_types_others",
  "cranial_surg1_reason",
  "cranial_surg1_reason_others",
  "cranial_surg1_delay",
  "cranial_surg1_delay_others",
  "cranial_surg1_notes",
  "cranial_surg2_start_dt",
  "cranial_surg2_end_dt",
  "cranial_surg2_types",
  "cranial_surg2_types_others",
  "cranial_surg2_reason",
  "cranial_surg2_reason_others",
  "cranial_surg2_delay",
  "cranial_surg2_delay_others",
  "cranial_surg2_notes",
  "cranial_surg3_start_dt",
  "cranial_surg3_end_dt",
  "cranial_surg3_types",
  "cranial_surg3_types_others",
  "cranial_surg3_reason",
  "cranial_surg3_reason_others",
  "cranial_surg3_delay",
  "cranial_surg3_delay_others",
  "cranial_surg3_notes",
  "cranial_surg4_start_dt",
  "cranial_surg4_end_dt",
  "cranial_surg4_types",
  "cranial_surg4_types_others",
  "cranial_surg4_reason",
  "cranial_surg4_reason_others",
  "cranial_surg4_delay",
  "cranial_surg4_delay_others",
  "cranial_surg4_notes",
  "cranial_surg5_start_dt",
  "cranial_surg5_end_dt",
  "cranial_surg5_types",
  "cranial_surg5_types_others",
  "cranial_surg5_reason",
  "cranial_surg5_reason_others",
  "cranial_surg5_delay",
  "cranial_surg5_delay_others",
  "cranial_surg5_notes",
  "surgeries_status",
  "mrs_6m",
  "gose_6m",
  "fu_yn_6m",
  "shunt_dependency_6m",
  "fu_d_6m",
  "mrs_12m",
  "gose_12m",
  "fu_yn_12m",
  "shunt_dependency_12m",
  "fu_d_12m",
  "final_status",
  "data_received",
  "data_id",
  "old_trach_start_d",
  "old_trach_stop_d",
  "d4_location",
  "d4_gcs_worst_dt",
  "d4_gcs_worst_asscond",
  "d4_gcs_worst_change24h",
  "d4_gcs_worst_change24h_cause",
  "d4_gcs_worst_e",
  "d4_gcs_worst_v",
  "d4_gcs_worst_m",
  "d4_gcs_worst_total",
  "d4_pupil_worst_sym",
  "d4_pupil_worst_lr_lt",
  "d4_pupil_worst_size_lt",
  "d4_pupil_worst_unknown_lt",
  "d4_pupil_worst_lr_rt",
  "d4_pupil_worst_size_rt",
  "d4_pupil_worst_unknown_rt",
  "d4_gcs_best",
  "d4_gcs_best_dt",
  "d4_gcs_best_asscond",
  "d4_gcs_best_change24h",
  "d4_gcs_best_change24h_cause",
  "d4_gcs_best_e",
  "d4_gcs_best_v",
  "d4_gcs_best_m",
  "d4_gcs_best_total",
  "d4_pupil_best_sym",
  "d4_pupil_best_lr_lt",
  "d4_pupil_best_size_lt",
  "d4_pupil_best_unknown_lt",
  "d4_pupil_best_lr_rt",
  "d4_pupil_best_size_rt",
  "d4_pupil_best_unknown_rt",
  "d4_neuroworse",
  "d4_neuroworse_type",
  "d4_neuroworse_action",
  "d4_til_dt",
  "d4_til_complete",
  "d4_til_position",
  "d4_til_position_flat",
  "d4_til_sedation",
  "d4_til_sedation_higher",
  "d4_til_sedation_suppression",
  "d4_til_sedation_nmb",
  "d4_til_csfdrain",
  "d4_til_csfdrainvol",
  "d4_til_fluidloading",
  "d4_til_vasopressor",
  "d4_til_hyperventilation",
  "d4_til_hyperventilation_mod",
  "d4_til_hyperventilation_intense",
  "d4_til_osm_mnt_low",
  "d4_til_osm_hts_low",
  "d4_til_osm_mnt_high",
  "d4_til_osm_hts_high",
  "d4_til_fever",
  "d4_til_ttm_mild",
  "d4_til_ttm_moderate",
  "d4_til_icp_surgery",
  "d4_til_icp_decomcrani",
  "d4_til_change_reason",
  "d4_til_summary",
  "d5_location",
  "d5_gcs_worst_dt",
  "d5_gcs_worst_asscond",
  "d5_gcs_worst_change24h",
  "d5_gcs_worst_change24h_cause",
  "d5_gcs_worst_e",
  "d5_gcs_worst_v",
  "d5_gcs_worst_m",
  "d5_gcs_worst_total",
  "d5_pupil_worst_sym",
  "d5_pupil_worst_lr_lt",
  "d5_pupil_worst_size_lt",
  "d5_pupil_worst_unknown_lt",
  "d5_pupil_worst_lr_rt",
  "d5_pupil_worst_size_rt",
  "d5_pupil_worst_unknown_rt",
  "d5_gcs_best",
  "d5_gcs_best_dt",
  "d5_gcs_best_asscond",
  "d5_gcs_best_change24h",
  "d5_gcs_best_change24h_cause",
  "d5_gcs_best_e",
  "d5_gcs_best_v",
  "d5_gcs_best_m",
  "d5_gcs_best_total",
  "d5_pupil_best_sym",
  "d5_pupil_best_lr_lt",
  "d5_pupil_best_size_lt",
  "d5_pupil_best_unknown_lt",
  "d5_pupil_best_lr_rt",
  "d5_pupil_best_size_rt",
  "d5_pupil_best_unknown_rt",
  "d5_neuroworse",
  "d5_neuroworse_type",
  "d5_neuroworse_action",
  "d5_til_dt",
  "d5_til_complete",
  "d5_til_position",
  "d5_til_position_flat",
  "d5_til_sedation",
  "d5_til_sedation_higher",
  "d5_til_sedation_suppression",
  "d5_til_sedation_nmb",
  "d5_til_csfdrain",
  "d5_til_csfdrainvol",
  "d5_til_fluidloading",
  "d5_til_vasopressor",
  "d5_til_hyperventilation",
  "d5_til_hyperventilation_mod",
  "d5_til_hyperventilation_intense",
  "d5_til_osm_mnt_low",
  "d5_til_osm_hts_low",
  "d5_til_osm_mnt_high",
  "d5_til_osm_hts_high",
  "d5_til_fever",
  "d5_til_ttm_mild",
  "d5_til_ttm_moderate",
  "d5_til_icp_surgery",
  "d5_til_icp_decomcrani",
  "d5_til_change_reason",
  "d5_til_summary",
  "d6_location",
  "d6_gcs_worst_dt",
  "d6_gcs_worst_asscond",
  "d6_gcs_worst_change24h",
  "d6_gcs_worst_change24h_cause",
  "d6_gcs_worst_e",
  "d6_gcs_worst_v",
  "d6_gcs_worst_m",
  "d6_gcs_worst_total",
  "d6_pupil_worst_sym",
  "d6_pupil_worst_lr_lt",
  "d6_pupil_worst_size_lt",
  "d6_pupil_worst_unknown_lt",
  "d6_pupil_worst_lr_rt",
  "d6_pupil_worst_size_rt",
  "d6_pupil_worst_unknown_rt",
  "d6_gcs_best",
  "d6_gcs_best_dt",
  "d6_gcs_best_asscond",
  "d6_gcs_best_change24h",
  "d6_gcs_best_change24h_cause",
  "d6_gcs_best_e",
  "d6_gcs_best_v",
  "d6_gcs_best_m",
  "d6_gcs_best_total",
  "d6_pupil_best_sym",
  "d6_pupil_best_lr_lt",
  "d6_pupil_best_size_lt",
  "d6_pupil_best_unknown_lt",
  "d6_pupil_best_lr_rt",
  "d6_pupil_best_size_rt",
  "d6_pupil_best_unknown_rt",
  "d6_neuroworse",
  "d6_neuroworse_type",
  "d6_neuroworse_action",
  "d6_til_dt",
  "d6_til_complete",
  "d6_til_position",
  "d6_til_position_flat",
  "d6_til_sedation",
  "d6_til_sedation_higher",
  "d6_til_sedation_suppression",
  "d6_til_sedation_nmb",
  "d6_til_csfdrain",
  "d6_til_csfdrainvol",
  "d6_til_fluidloading",
  "d6_til_vasopressor",
  "d6_til_hyperventilation",
  "d6_til_hyperventilation_mod",
  "d6_til_hyperventilation_intense",
  "d6_til_osm_mnt_low",
  "d6_til_osm_hts_low",
  "d6_til_osm_mnt_high",
  "d6_til_osm_hts_high",
  "d6_til_fever",
  "d6_til_ttm_mild",
  "d6_til_ttm_moderate",
  "d6_til_icp_surgery",
  "d6_til_icp_decomcrani",
  "d6_til_change_reason",
  "d6_til_summary",
  "d7_location",
  "d7_gcs_worst_dt",
  "d7_gcs_worst_asscond",
  "d7_gcs_worst_change24h",
  "d7_gcs_worst_change24h_cause",
  "d7_gcs_worst_e",
  "d7_gcs_worst_v",
  "d7_gcs_worst_m",
  "d7_gcs_worst_total",
  "d7_pupil_worst_sym",
  "d7_pupil_worst_lr_lt",
  "d7_pupil_worst_size_lt",
  "d7_pupil_worst_unknown_lt",
  "d7_pupil_worst_lr_rt",
  "d7_pupil_worst_size_rt",
  "d7_pupil_worst_unknown_rt",
  "d7_gcs_best",
  "d7_gcs_best_dt",
  "d7_gcs_best_asscond",
  "d7_gcs_best_change24h",
  "d7_gcs_best_change24h_cause",
  "d7_gcs_best_e",
  "d7_gcs_best_v",
  "d7_gcs_best_m",
  "d7_gcs_best_total",
  "d7_pupil_best_sym",
  "d7_pupil_best_lr_lt",
  "d7_pupil_best_size_lt",
  "d7_pupil_best_unknown_lt",
  "d7_pupil_best_lr_rt",
  "d7_pupil_best_size_rt",
  "d7_pupil_best_unknown_rt",
  "d7_neuroworse",
  "d7_neuroworse_type",
  "d7_neuroworse_action",
  "d7_til_dt",
  "d7_til_complete",
  "d7_til_position",
  "d7_til_position_flat",
  "d7_til_sedation",
  "d7_til_sedation_higher",
  "d7_til_sedation_suppression",
  "d7_til_sedation_nmb",
  "d7_til_csfdrain",
  "d7_til_csfdrainvol",
  "d7_til_fluidloading",
  "d7_til_vasopressor",
  "d7_til_hyperventilation",
  "d7_til_hyperventilation_mod",
  "d7_til_hyperventilation_intense",
  "d7_til_osm_mnt_low",
  "d7_til_osm_hts_low",
  "d7_til_osm_mnt_high",
  "d7_til_osm_hts_high",
  "d7_til_fever",
  "d7_til_ttm_mild",
  "d7_til_ttm_moderate",
  "d7_til_icp_surgery",
  "d7_til_icp_decomcrani",
  "d7_til_change_reason",
  "d7_til_summary",
  "d8_location",
  "d8_gcs_worst_dt",
  "d8_gcs_worst_asscond",
  "d8_gcs_worst_change24h",
  "d8_gcs_worst_change24h_cause",
  "d8_gcs_worst_e",
  "d8_gcs_worst_v",
  "d8_gcs_worst_m",
  "d8_gcs_worst_total",
  "d8_pupil_worst_sym",
  "d8_pupil_worst_lr_lt",
  "d8_pupil_worst_size_lt",
  "d8_pupil_worst_unknown_lt",
  "d8_pupil_worst_lr_rt",
  "d8_pupil_worst_size_rt",
  "d8_pupil_worst_unknown_rt",
  "d8_gcs_best",
  "d8_gcs_best_dt",
  "d8_gcs_best_asscond",
  "d8_gcs_best_change24h",
  "d8_gcs_best_change24h_cause",
  "d8_gcs_best_e",
  "d8_gcs_best_v",
  "d8_gcs_best_m",
  "d8_gcs_best_total",
  "d8_pupil_best_sym",
  "d8_pupil_best_lr_lt",
  "d8_pupil_best_size_lt",
  "d8_pupil_best_unknown_lt",
  "d8_pupil_best_lr_rt",
  "d8_pupil_best_size_rt",
  "d8_pupil_best_unknown_rt",
  "d8_neuroworse",
  "d8_neuroworse_type",
  "d8_neuroworse_action",
  "d8_til_dt",
  "d8_til_complete",
  "d8_til_position",
  "d8_til_position_flat",
  "d8_til_sedation",
  "d8_til_sedation_higher",
  "d8_til_sedation_suppression",
  "d8_til_sedation_nmb",
  "d8_til_csfdrain",
  "d8_til_csfdrainvol",
  "d8_til_fluidloading",
  "d8_til_vasopressor",
  "d8_til_hyperventilation",
  "d8_til_hyperventilation_mod",
  "d8_til_hyperventilation_intense",
  "d8_til_osm_mnt_low",
  "d8_til_osm_hts_low",
  "d8_til_osm_mnt_high",
  "d8_til_osm_hts_high",
  "d8_til_fever",
  "d8_til_ttm_mild",
  "d8_til_ttm_moderate",
  "d8_til_icp_surgery",
  "d8_til_icp_decomcrani",
  "d8_til_change_reason",
  "d8_til_summary",
  "d9_location",
  "d9_gcs_worst_dt",
  "d9_gcs_worst_asscond",
  "d9_gcs_worst_change24h",
  "d9_gcs_worst_change24h_cause",
  "d9_gcs_worst_e",
  "d9_gcs_worst_v",
  "d9_gcs_worst_m",
  "d9_gcs_worst_total",
  "d9_pupil_worst_sym",
  "d9_pupil_worst_lr_lt",
  "d9_pupil_worst_size_lt",
  "d9_pupil_worst_unknown_lt",
  "d9_pupil_worst_lr_rt",
  "d9_pupil_worst_size_rt",
  "d9_pupil_worst_unknown_rt",
  "d9_gcs_best",
  "d9_gcs_best_dt",
  "d9_gcs_best_asscond",
  "d9_gcs_best_change24h",
  "d9_gcs_best_change24h_cause",
  "d9_gcs_best_e",
  "d9_gcs_best_v",
  "d9_gcs_best_m",
  "d9_gcs_best_total",
  "d9_pupil_best_sym",
  "d9_pupil_best_lr_lt",
  "d9_pupil_best_size_lt",
  "d9_pupil_best_unknown_lt",
  "d9_pupil_best_lr_rt",
  "d9_pupil_best_size_rt",
  "d9_pupil_best_unknown_rt",
  "d9_neuroworse",
  "d9_neuroworse_type",
  "d9_neuroworse_action",
  "d9_til_dt",
  "d9_til_complete",
  "d9_til_position",
  "d9_til_position_flat",
  "d9_til_sedation",
  "d9_til_sedation_higher",
  "d9_til_sedation_suppression",
  "d9_til_sedation_nmb",
  "d9_til_csfdrain",
  "d9_til_csfdrainvol",
  "d9_til_fluidloading",
  "d9_til_vasopressor",
  "d9_til_hyperventilation",
  "d9_til_hyperventilation_mod",
  "d9_til_hyperventilation_intense",
  "d9_til_osm_mnt_low",
  "d9_til_osm_hts_low",
  "d9_til_osm_mnt_high",
  "d9_til_osm_hts_high",
  "d9_til_fever",
  "d9_til_ttm_mild",
  "d9_til_ttm_moderate",
  "d9_til_icp_surgery",
  "d9_til_icp_decomcrani",
  "d9_til_change_reason",
  "d9_til_summary",
  "d10_location",
  "d10_gcs_worst_dt",
  "d10_gcs_worst_asscond",
  "d10_gcs_worst_change24h",
  "d10_gcs_worst_change24h_cause",
  "d10_gcs_worst_e",
  "d10_gcs_worst_v",
  "d10_gcs_worst_m",
  "d10_gcs_worst_total",
  "d10_pupil_worst_sym",
  "d10_pupil_worst_lr_lt",
  "d10_pupil_worst_size_lt",
  "d10_pupil_worst_unknown_lt",
  "d10_pupil_worst_lr_rt",
  "d10_pupil_worst_size_rt",
  "d10_pupil_worst_unknown_rt",
  "d10_gcs_best",
  "d10_gcs_best_dt",
  "d10_gcs_best_asscond",
  "d10_gcs_best_change24h",
  "d10_gcs_best_change24h_cause",
  "d10_gcs_best_e",
  "d10_gcs_best_v",
  "d10_gcs_best_m",
  "d10_gcs_best_total",
  "d10_pupil_best_sym",
  "d10_pupil_best_lr_lt",
  "d10_pupil_best_size_lt",
  "d10_pupil_best_unknown_lt",
  "d10_pupil_best_lr_rt",
  "d10_pupil_best_size_rt",
  "d10_pupil_best_unknown_rt",
  "d10_neuroworse",
  "d10_neuroworse_type",
  "d10_neuroworse_action",
  "d10_til_dt",
  "d10_til_complete",
  "d10_til_position",
  "d10_til_position_flat",
  "d10_til_sedation",
  "d10_til_sedation_higher",
  "d10_til_sedation_suppression",
  "d10_til_sedation_nmb",
  "d10_til_csfdrain",
  "d10_til_csfdrainvol",
  "d10_til_fluidloading",
  "d10_til_vasopressor",
  "d10_til_hyperventilation",
  "d10_til_hyperventilation_mod",
  "d10_til_hyperventilation_intense",
  "d10_til_osm_mnt_low",
  "d10_til_osm_hts_low",
  "d10_til_osm_mnt_high",
  "d10_til_osm_hts_high",
  "d10_til_fever",
  "d10_til_ttm_mild",
  "d10_til_ttm_moderate",
  "d10_til_icp_surgery",
  "d10_til_icp_decomcrani",
  "d10_til_change_reason",
  "d10_til_summary",
  "d11_location",
  "d11_gcs_worst_dt",
  "d11_gcs_worst_asscond",
  "d11_gcs_worst_change24h",
  "d11_gcs_worst_change24h_cause",
  "d11_gcs_worst_e",
  "d11_gcs_worst_v",
  "d11_gcs_worst_m",
  "d11_gcs_worst_total",
  "d11_pupil_worst_sym",
  "d11_pupil_worst_lr_lt",
  "d11_pupil_worst_size_lt",
  "d11_pupil_worst_unknown_lt",
  "d11_pupil_worst_lr_rt",
  "d11_pupil_worst_size_rt",
  "d11_pupil_worst_unknown_rt",
  "d11_gcs_best",
  "d11_gcs_best_dt",
  "d11_gcs_best_asscond",
  "d11_gcs_best_change24h",
  "d11_gcs_best_change24h_cause",
  "d11_gcs_best_e",
  "d11_gcs_best_v",
  "d11_gcs_best_m",
  "d11_gcs_best_total",
  "d11_pupil_best_sym",
  "d11_pupil_best_lr_lt",
  "d11_pupil_best_size_lt",
  "d11_pupil_best_unknown_lt",
  "d11_pupil_best_lr_rt",
  "d11_pupil_best_size_rt",
  "d11_pupil_best_unknown_rt",
  "d11_neuroworse",
  "d11_neuroworse_type",
  "d11_neuroworse_action",
  "d11_til_dt",
  "d11_til_complete",
  "d11_til_position",
  "d11_til_position_flat",
  "d11_til_sedation",
  "d11_til_sedation_higher",
  "d11_til_sedation_suppression",
  "d11_til_sedation_nmb",
  "d11_til_csfdrain",
  "d11_til_csfdrainvol",
  "d11_til_fluidloading",
  "d11_til_vasopressor",
  "d11_til_hyperventilation",
  "d11_til_hyperventilation_mod",
  "d11_til_hyperventilation_intense",
  "d11_til_osm_mnt_low",
  "d11_til_osm_hts_low",
  "d11_til_osm_mnt_high",
  "d11_til_osm_hts_high",
  "d11_til_fever",
  "d11_til_ttm_mild",
  "d11_til_ttm_moderate",
  "d11_til_icp_surgery",
  "d11_til_icp_decomcrani",
  "d11_til_change_reason",
  "d11_til_summary",
  "d12_location",
  "d12_gcs_worst_dt",
  "d12_gcs_worst_asscond",
  "d12_gcs_worst_change24h",
  "d12_gcs_worst_change24h_cause",
  "d12_gcs_worst_e",
  "d12_gcs_worst_v",
  "d12_gcs_worst_m",
  "d12_gcs_worst_total",
  "d12_pupil_worst_sym",
  "d12_pupil_worst_lr_lt",
  "d12_pupil_worst_size_lt",
  "d12_pupil_worst_unknown_lt",
  "d12_pupil_worst_lr_rt",
  "d12_pupil_worst_size_rt",
  "d12_pupil_worst_unknown_rt",
  "d12_gcs_best",
  "d12_gcs_best_dt",
  "d12_gcs_best_asscond",
  "d12_gcs_best_change24h",
  "d12_gcs_best_change24h_cause",
  "d12_gcs_best_e",
  "d12_gcs_best_v",
  "d12_gcs_best_m",
  "d12_gcs_best_total",
  "d12_pupil_best_sym",
  "d12_pupil_best_lr_lt",
  "d12_pupil_best_size_lt",
  "d12_pupil_best_unknown_lt",
  "d12_pupil_best_lr_rt",
  "d12_pupil_best_size_rt",
  "d12_pupil_best_unknown_rt",
  "d12_neuroworse",
  "d12_neuroworse_type",
  "d12_neuroworse_action",
  "d12_til_dt",
  "d12_til_complete",
  "d12_til_position",
  "d12_til_position_flat",
  "d12_til_sedation",
  "d12_til_sedation_higher",
  "d12_til_sedation_suppression",
  "d12_til_sedation_nmb",
  "d12_til_csfdrain",
  "d12_til_csfdrainvol",
  "d12_til_fluidloading",
  "d12_til_vasopressor",
  "d12_til_hyperventilation",
  "d12_til_hyperventilation_mod",
  "d12_til_hyperventilation_intense",
  "d12_til_osm_mnt_low",
  "d12_til_osm_hts_low",
  "d12_til_osm_mnt_high",
  "d12_til_osm_hts_high",
  "d12_til_fever",
  "d12_til_ttm_mild",
  "d12_til_ttm_moderate",
  "d12_til_icp_surgery",
  "d12_til_icp_decomcrani",
  "d12_til_change_reason",
  "d12_til_summary",
  "d13_location",
  "d13_gcs_worst_dt",
  "d13_gcs_worst_asscond",
  "d13_gcs_worst_change24h",
  "d13_gcs_worst_change24h_cause",
  "d13_gcs_worst_e",
  "d13_gcs_worst_v",
  "d13_gcs_worst_m",
  "d13_gcs_worst_total",
  "d13_pupil_worst_sym",
  "d13_pupil_worst_lr_lt",
  "d13_pupil_worst_size_lt",
  "d13_pupil_worst_unknown_lt",
  "d13_pupil_worst_lr_rt",
  "d13_pupil_worst_size_rt",
  "d13_pupil_worst_unknown_rt",
  "d13_gcs_best",
  "d13_gcs_best_dt",
  "d13_gcs_best_asscond",
  "d13_gcs_best_change24h",
  "d13_gcs_best_change24h_cause",
  "d13_gcs_best_e",
  "d13_gcs_best_v",
  "d13_gcs_best_m",
  "d13_gcs_best_total",
  "d13_pupil_best_sym",
  "d13_pupil_best_lr_lt",
  "d13_pupil_best_size_lt",
  "d13_pupil_best_unknown_lt",
  "d13_pupil_best_lr_rt",
  "d13_pupil_best_size_rt",
  "d13_pupil_best_unknown_rt",
  "d13_neuroworse",
  "d13_neuroworse_type",
  "d13_neuroworse_action",
  "d13_til_dt",
  "d13_til_complete",
  "d13_til_position",
  "d13_til_position_flat",
  "d13_til_sedation",
  "d13_til_sedation_higher",
  "d13_til_sedation_suppression",
  "d13_til_sedation_nmb",
  "d13_til_csfdrain",
  "d13_til_csfdrainvol",
  "d13_til_fluidloading",
  "d13_til_vasopressor",
  "d13_til_hyperventilation",
  "d13_til_hyperventilation_mod",
  "d13_til_hyperventilation_intense",
  "d13_til_osm_mnt_low",
  "d13_til_osm_hts_low",
  "d13_til_osm_mnt_high",
  "d13_til_osm_hts_high",
  "d13_til_fever",
  "d13_til_ttm_mild",
  "d13_til_ttm_moderate",
  "d13_til_icp_surgery",
  "d13_til_icp_decomcrani",
  "d13_til_change_reason",
  "d13_til_summary",
  "d14_location",
  "d14_gcs_worst_dt",
  "d14_gcs_worst_asscond",
  "d14_gcs_worst_change24h",
  "d14_gcs_worst_change24h_cause",
  "d14_gcs_worst_e",
  "d14_gcs_worst_v",
  "d14_gcs_worst_m",
  "d14_gcs_worst_total",
  "d14_pupil_worst_sym",
  "d14_pupil_worst_lr_lt",
  "d14_pupil_worst_size_lt",
  "d14_pupil_worst_unknown_lt",
  "d14_pupil_worst_lr_rt",
  "d14_pupil_worst_size_rt",
  "d14_pupil_worst_unknown_rt",
  "d14_gcs_best",
  "d14_gcs_best_dt",
  "d14_gcs_best_asscond",
  "d14_gcs_best_change24h",
  "d14_gcs_best_change24h_cause",
  "d14_gcs_best_e",
  "d14_gcs_best_v",
  "d14_gcs_best_m",
  "d14_gcs_best_total",
  "d14_pupil_best_sym",
  "d14_pupil_best_lr_lt",
  "d14_pupil_best_size_lt",
  "d14_pupil_best_unknown_lt",
  "d14_pupil_best_lr_rt",
  "d14_pupil_best_size_rt",
  "d14_pupil_best_unknown_rt",
  "d14_neuroworse",
  "d14_neuroworse_type",
  "d14_neuroworse_action",
  "d14_til_dt",
  "d14_til_complete",
  "d14_til_position",
  "d14_til_position_flat",
  "d14_til_sedation",
  "d14_til_sedation_higher",
  "d14_til_sedation_suppression",
  "d14_til_sedation_nmb",
  "d14_til_csfdrain",
  "d14_til_csfdrainvol",
  "d14_til_fluidloading",
  "d14_til_vasopressor",
  "d14_til_hyperventilation",
  "d14_til_hyperventilation_mod",
  "d14_til_hyperventilation_intense",
  "d14_til_osm_mnt_low",
  "d14_til_osm_hts_low",
  "d14_til_osm_mnt_high",
  "d14_til_osm_hts_high",
  "d14_til_fever",
  "d14_til_ttm_mild",
  "d14_til_ttm_moderate",
  "d14_til_icp_surgery",
  "d14_til_icp_decomcrani",
  "d14_til_change_reason",
  "d14_til_summary",
  "d15_location",
  "d15_gcs_worst_dt",
  "d15_gcs_worst_asscond",
  "d15_gcs_worst_change24h",
  "d15_gcs_worst_change24h_cause",
  "d15_gcs_worst_e",
  "d15_gcs_worst_v",
  "d15_gcs_worst_m",
  "d15_gcs_worst_total",
  "d15_pupil_worst_sym",
  "d15_pupil_worst_lr_lt",
  "d15_pupil_worst_size_lt",
  "d15_pupil_worst_unknown_lt",
  "d15_pupil_worst_lr_rt",
  "d15_pupil_worst_size_rt",
  "d15_pupil_worst_unknown_rt",
  "d15_gcs_best",
  "d15_gcs_best_dt",
  "d15_gcs_best_asscond",
  "d15_gcs_best_change24h",
  "d15_gcs_best_change24h_cause",
  "d15_gcs_best_e",
  "d15_gcs_best_v",
  "d15_gcs_best_m",
  "d15_gcs_best_total",
  "d15_pupil_best_sym",
  "d15_pupil_best_lr_lt",
  "d15_pupil_best_size_lt",
  "d15_pupil_best_unknown_lt",
  "d15_pupil_best_lr_rt",
  "d15_pupil_best_size_rt",
  "d15_pupil_best_unknown_rt",
  "d15_neuroworse",
  "d15_neuroworse_type",
  "d15_neuroworse_action",
  "d15_til_dt",
  "d15_til_complete",
  "d15_til_position",
  "d15_til_position_flat",
  "d15_til_sedation",
  "d15_til_sedation_higher",
  "d15_til_sedation_suppression",
  "d15_til_sedation_nmb",
  "d15_til_csfdrain",
  "d15_til_csfdrainvol",
  "d15_til_fluidloading",
  "d15_til_vasopressor",
  "d15_til_hyperventilation",
  "d15_til_hyperventilation_mod",
  "d15_til_hyperventilation_intense",
  "d15_til_osm_mnt_low",
  "d15_til_osm_hts_low",
  "d15_til_osm_mnt_high",
  "d15_til_osm_hts_high",
  "d15_til_fever",
  "d15_til_ttm_mild",
  "d15_til_ttm_moderate",
  "d15_til_icp_surgery",
  "d15_til_icp_decomcrani",
  "d15_til_change_reason",
  "d15_til_summary",
];

export default formFieldKeys;

// 향후 label, type 정보를 채워 넣을 수 있도록 기본 객체 배열도 함께 export
// 현재는 label은 id와 동일, type은 'text'로 기본 설정해 둔다.
/*
 * VIP 11 - New Case Form Field Definitions (11FormFields.js)
 * ============================================================
 *
 * 본 파일은 VIP 11 New Case 폼의 모든 필드 정의를 포함합니다.
 *
 * 1페이지 구성 (Step 1: Initial):
 * --------------------------------
 * 1. 기본 정보 섹션:
 *    - index_injury: 뇌손상 종류 (조건부 렌더링의 핵심 필드)
 *    - index_injury_memo: 뇌손상 종류 메모
 *    - hos_id: 환자번호
 *    - age, sex, ht, wt: 환자 기본 정보
 *    - hospital: 병원 코드 (user_value 기반 자동 매핑)
 *
 * 2. 시간 정보 섹션:
 *    - last_normal_dt: 마지막 정상 확인 일시
 *    - symptom_onset_dt: 증상 발생 일시
 *    - arrival_dt: 응급실 방문 일시
 *
 * 3. 응급실 정보 섹션:
 *    - arrival_from: 전원여부
 *    - arrival_airway/breathing/circulation: ABC 평가
 *    - 생체징후: SBP, DBP, HR, Temp, RR, SpO2, RR_unk
 *
 * 4. GCS 평가 섹션 (자동 계산):
 *    - arrival_gcs_e/v/m: GCS 구성 요소
 *    - arrival_gcs_total: 자동 계산된 총합
 *    - arrival_gcs_confounder: 측정 상황
 *
 * 5. 동공 검사 섹션:
 *    - pupil size/response (Rt/Lt)
 *    - pupillometer 시행 여부
 *
 * 6. 영상 검사 섹션:
 *    - arrival_image: 영상 종류 (checkbox)
 *    - arrival_image_dt: 촬영 시각
 *
 * 7. 과거력 섹션:
 *    - 동반질환: hx_htn, hx_dm, hx_cirrhosis, hx_stroke, hx_malignancy, hx_ckd
 *    - 약물력: hx_plt, hx_plt_type, hx_coa, hx_coa_type
 *    - 사회력: hx_alcohol, hx_smok, hx_smok_pyrs
 *    - 병전 상태: hx_pre_mrs
 *
 * 8. 조건부 섹션 (index_injury 값에 따라):
 *    - SAH: 30여개 SAH 관련 필드 (WFNS, Fisher scale, 동맥류 정보 등)
 *    - TBI: 22개 TBI 관련 필드 (ISS score, CT 소견 등)
 *    - ICH/IVH: 35여개 ICH/IVH 관련 필드 (Modified Graeb scale, ICH score 등)
 *
 * 9. 상태 필드:
 *    - initial_status: 완료 상태 체크
 *
 * 자동 계산 로직:
 * ---------------
 * 1. GCS Total (arrival_gcs_total): E+V+M 합산, 특별 조건 처리
 * 2. SAH Aspect Ratio (aneurysm_aspect_ratio): height / neck_max
 * 3. SAH Bottleneck Factor (aneurysm_bottleneck_factor): width / neck_max
 * 4. TBI ISS Score (tbi_iss_score): 상위 3개 AIS 점수의 제곱합
 * 5. TBI Rotterdam CT Score (tbi_rotterdam): 1 + 기저조 + 중선편위 + EDH + 허혈성병변
 * 6. ICH Score (ich_score): GCS + ICH volume + IVH + Infratentorial + Age
 * 7. Modified Graeb Scale (ivh_mgraeb_score): 16개 IVH 필드의 점수 합산
 */

export const formFieldDefs = [
  {
    id: "index_injury",
    label: "뇌손상 종류 (index_injury)",
    type: "radio",
    options: [
      { label: "TBI", value: "TBI" },
      { label: "SAH (ruptured aneurysm)", value: "SAH (ruptured aneurysm)" },
      {
        label: "ICH (primary, secondary) / IVH",
        value: "ICH (primary, secondary) / IVH",
      },
      { label: "Ischemic stroke", value: "Ischemic stroke" },
      { label: "Others", value: "Others" },
    ],
    detail:
      "해당 필드에서 선택한 값에 따라서 다른 섹션이 활성화가 됩니다. TBI 선택 시 22개 TBI 필드, SAH 선택 시 30여개 SAH 필드, ICH/IVH 선택 시 35여개 ICH/IVH 필드가 조건부 렌더링됩니다.",
  },
  {
    id: "index_injury_memo",
    label: "뇌손상 종류 메모 (index_injury_memo)",
    type: "text",
  },
  {
    id: "hos_id",
    label: "환자번호 (hos_id)",
    type: "text",
  },

  {
    id: "age",
    label: "나이 (age)",
    type: "text",
  },

  {
    id: "sex",
    label: "성별 (sex)",
    type: "radio",
    options: [
      { label: "남자", value: "남자" },
      { label: "여자", value: "여자" },
    ],
  },

  {
    id: "ht",
    label: "키 (ht)",
    type: "text",
    unit: "cm",
  },
  {
    id: "wt",
    label: "체중 (wt)",
    type: "text",
    unit: "kg",
  },

  {
    id: "hospital",
    label: "병원 (hospital)",
    type: "radio",
    options: [
      { label: "A", value: "A" },
      { label: "B", value: "B" },
      { label: "C", value: "C" },
      { label: "D", value: "D" },
      { label: "E", value: "E" },
      { label: "F", value: "F" },
      { label: "G", value: "G" },
      { label: "H", value: "H" },
      { label: "I", value: "I" },
    ],
    detail:
      "유저가 선택이 불가하며, 계정에 따라 자동으로 선택이 됩니다. user_value의 10의 자리(1~9)를 알파벳(A~I)에 매핑하여 자동 설정됩니다. (10→A, 20→B, ..., 90→I)",
    readonly: true,
    autoCalculated: true,
  },

  {
    id: "last_normal_dt",
    label: "마지막 정상 확인 일시 (last_normal_dt)",
    type: "text",
    detail:
      "YYYY-MM-DD HH:MM 형식으로 붙여넣기가 가능한 텍스트 형식 필드로 변경 요청이 있었음.",
  },
  {
    id: "symptom_onset_dt",
    label: "증상 발생 일시 (symptom_onset_dt)",
    type: "text",
    detail:
      "YYYY-MM-DD HH:MM 형식으로 붙여넣기가 가능한 텍스트 형식 필드로 변경 요청이 있었음.",
  },
  {
    id: "arrival_dt",
    label: "응급실 방문 일시(원내는 contact 된 일시) (arrival_dt)",
    type: "text",
    detail:
      "YYYY-MM-DD HH:MM 형식으로 붙여넣기가 가능한 텍스트 형식 필드로 변경 요청이 있었음.",
  },

  {
    id: "arrival_from",
    label: "전원여부 (arrival_from)",
    type: "radio",
    options: [
      { label: "Direct", value: "Direct" },
      { label: "Other hospital", value: "Other hospital" },
      { label: "In-hospital", value: "In-hospital" },
    ],
  },

  {
    id: "arrival_airway",
    label: "ER 도착시 Airway (arrival_airway)",
    type: "radio",
    options: [
      { label: "Clear", value: "Clear" },
      { label: "Obstructed", value: "Obstructed" },
      { label: "Adjunctive Airway", value: "Adjunctive Airway" },
      { label: "Intubated", value: "Intubated" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_breathing",
    label: "ER 도착시 breathing (arrival_breathing)",
    type: "radio",
    options: [
      { label: "Spontaneous, adequate", value: "Spontaneous, adequate" },
      {
        label: "Spontaneous, insufficient",
        value: "Spontaneous, insufficient",
      },
      {
        label: "Manual support with bag, valve, mask",
        value: "Manual support with bag, valve, mask",
      },
      { label: "Mechanical ventilation", value: "Mechanical ventilation" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_circulation",
    label: "ER 도착시 circulation (arrival_circulation)",
    type: "radio",
    options: [
      { label: "No specific therapy", value: "No specific therapy" },
      { label: "IV Fluids", value: "IV Fluids" },
      { label: "Vasopressors", value: "Vasopressors" },
      { label: "CPR", value: "CPR" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_sbp",
    label: "ER 도착시 수축기혈압 (arrival_sbp)",
    type: "text",
    unit: "mmHg",
  },

  {
    id: "arrival_dbp",
    label: "ER 도착시 이완기혈압 (arrival_dbp)",
    type: "text",
    unit: "mmHg",
  },

  {
    id: "arrival_hr",
    label: "ER 도착시 심박수 (arrival_hr)",
    type: "text",
    unit: "bpm",
  },

  {
    id: "arrival_temp",
    label: "ER 도착시 체온 (arrival_temp)",
    type: "text",
    unit: "°C",
  },

  {
    id: "arrival_rr",
    label: "ER 도착시 호흡수 (arrival_rr)",
    type: "text",
  },

  {
    id: "arrival_spo2",
    label: "ER 도착시 산소포화도 (arrival_spo2)",
    type: "text",
    unit: "%",
  },

  {
    id: "arrival_rr_unk",
    label: "ER 도착시 호흡수: 인공 호흡여부 (arrival_rr_unk)",
    type: "radio",
    options: [
      { label: "Spontaneous", value: "Spontaneous" },
      { label: "Ventilated", value: "Ventilated" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_gcs_e",
    label: "내원 후 첫 gcs_eye (arrival_gcs_e)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : To pain", value: "2 : To pain" },
      { label: "3 : To speech", value: "3 : To speech" },
      { label: "4 : Spontaneously", value: "4 : Spontaneously" },
      { label: "Untestable (swollen)", value: "0 : Untestable (swollen)" },
      { label: "Untestable (other)", value: "0 : Untestable (other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    detail:
      "GCS 자동 합계 계산에 사용되는 구성 요소 중 하나입니다. E 또는 M이 0점이면 총점=0, V가 0점이면 (E+M) 합에 보정치 가산(≤6→+1, 7→+2, 8~9→+4, 10→+5), 그 외는 E+V+M 단순 합산으로 arrival_gcs_total에 자동 계산됩니다.",
    calculationInput: true,
    affectsField: "arrival_gcs_total",
  },
  {
    id: "arrival_gcs_v",
    label: "내원 후 첫 gcs_verbal (arrival_gcs_v)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      {
        label: "2 : Incomprehensible sound",
        value: "2 : Incomprehensible sound",
      },
      { label: "3 : Inappropriate words", value: "3 : Inappropriate words" },
      { label: "4 : Spontaneously", value: "4 : Spontaneously" },
      { label: "4 : Confused", value: "4 : Confused" },
      { label: "5 : Oriented", value: "5 : Oriented" },
      {
        label: "Untestable (tracheotomy/endotracheal tube)",
        value: "0 : Untestable (tracheotomy/endotracheal tube)",
      },
      { label: "Untestable (Other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    detail:
      "GCS 자동 합계 계산에 사용되는 구성 요소 중 하나입니다. V가 0점일 때 특별한 보정 로직이 적용됩니다: (E+M) 합이 ≤6이면 +1, 7이면 +2, 8~9면 +4, 10이면 +5 점을 가산하여 arrival_gcs_total에 자동 계산됩니다.",
    calculationInput: true,
    affectsField: "arrival_gcs_total",
  },
  {
    id: "arrival_gcs_m",
    label: "내원 후 첫 gcs_motor (arrival_gcs_m)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : Abnormal extension", value: "2 : Abnormal extension" },
      { label: "3 : Abnormal flexion", value: "3 : Abnormal flexion" },
      {
        label: "4 : Normal flexion/withdrawal",
        value: "4 : Normal flexion/withdrawal",
      },
      { label: "5 : Localizes to pain", value: "5 : Localizes to pain" },
      { label: "6 : Localizes to pain", value: "6 : Localizes to pain" },
      {
        label: "Untestable (Deep sedation/paralyzed)",
        value: "0 : Untestable (Deep sedation/paralyzed)",
      },
      { label: " Untestable (Other)", value: "0 :  Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    detail:
      "GCS 자동 합계 계산에 사용되는 구성 요소 중 하나입니다. E 또는 M이 0점이면 총점=0으로 설정됩니다. 그 외의 경우 E+V+M을 합산하여 arrival_gcs_total에 자동 계산됩니다.",
    calculationInput: true,
    affectsField: "arrival_gcs_total",
  },

  {
    id: "arrival_gcs_total",
    label: "내원 후 첫 GCS (arrival_gcs_total)",
    type: "text",
    detail:
      "GCS E, V, M 값을 기반으로 자동 계산되는 총합 필드입니다. 계산 로직: (1) E 또는 M이 0점 → 총점=0, (2) V가 0점 → (E+M) 합에 보정치 가산(≤6→+1, 7→+2, 8~9→+4, 10→+5), (3) 그 외 → E+V+M 단순 합산. 초기값은 빈 문자열이며 모든 구성 요소 선택 완료 시 자동 계산됩니다.",
    readonly: true,
    autoCalculated: true,
    calculationFormula:
      "arrival_gcs_e + arrival_gcs_v + arrival_gcs_m (with special conditions)",
    calculationInputs: ["arrival_gcs_e", "arrival_gcs_v", "arrival_gcs_m"],
  },

  {
    id: "arrival_gcs_confounder",
    label: "GCS 측정시 상황 (arrival_gcs_confounder)",
    type: "radio",
    options: [
      { label: "GCS Accurate", value: "GCS Accurate" },
      { label: "Alcohol/drugs of abuse", value: "Alcohol/drugs of abuse" },
      { label: "C-spine injury", value: "C-spine injury" },
      { label: "Hypoxia/hypotension", value: "Hypoxia/hypotension" },
      { label: "Hypothermia", value: "Hypothermia" },
      { label: "Sedation", value: "Sedation" },
      { label: "Paralytic", value: "Paralytic" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_pupil_size_rt",
    label: "내원 후 첫 pupil size, Rt (arrival_pupil_size_rt)",
    type: "text",
    unit: "mm",
  },

  {
    id: "arrival_pupil_size_lt",
    label: "내원 후 첫 pupil size, Lt (arrival_pupil_size_lt)",
    type: "text",
    unit: "mm",
  },

  {
    id: "arrival_pupil_react_rt",
    label: "내원 후 첫 pupil response, Rt (arrival_pupil_react_rt)",
    type: "radio",
    options: [
      { label: "+ (Brisk)", value: "+ (Brisk)" },
      { label: "+ (Sluggish)", value: "+ (Sluggish)" },
      { label: "- (Negative)", value: "- (Negative)" },
      { label: "Untestable", value: "Untestable" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_pupil_react_lt",
    label: "내원 후 첫 pupil response, Lt (arrival_pupil_react_lt)",
    type: "radio",
    options: [
      { label: "+ (Brisk)", value: "+ (Brisk)" },
      { label: "+ (Sluggish)", value: "+ (Sluggish)" },
      { label: "- (Negative)", value: "- (Negative)" },
      { label: "Untestable", value: "Untestable" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "arrival_pupillometer_yn",
    label:
      "초기 (ER or In-hospital) Pupillometer 시행 여부 (arrival_pupillometer_yn)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
  },

  {
    id: "arrival_image",
    label: "응급실에서 촬영한 영상 (모두 선택) (arrival_image)",
    type: "checkbox", // multiple choice
    options: [
      { label: "Noncontrast CT Brain", value: "Noncontrast CT Brain" },
      { label: "CT Angio", value: "CT Angio" },
      { label: "CT perfusion", value: "CT perfusion" },
      { label: "MRI", value: "MRI" },
      { label: "TFCA", value: "TFCA" },
    ],
  },

  {
    id: "arrival_image_dt",
    label: "응급실에서 촬영한 최초 영상 시각 (arrival_image_dt)",
    type: "text",
    detail:
      "YYYY-MM-DD HH:MM 형식으로 붙여넣기가 가능한 텍스트 형식 필드로 변경 요청이 있었음.",
  },

  {
    id: "hx_htn",
    label: "고혈압 유무 (hx_htn)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_dm",
    label: "당뇨병 유무 (hx_dm)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_cirrhosis",
    label: "간경화 유무 (hx_cirrhosis)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_stroke",
    label: "뇌졸중 유무 (hx_stroke)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_malignancy",
    label: "악성종양 유무 (hx_malignancy)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_ckd",
    label: "Chronic kidney disease 유무(stage III 이상) (hx_ckd)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },

  {
    id: "hx_plt",
    label: "antiplatelet 복용력 (hx_plt)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_plt_type",
    label: "antiplatelet 종류 (hx_plt_type)",
    type: "checkbox",
    options: [
      { label: "Aspirin", value: "Aspirin" },
      { label: "Clopidogrel", value: "Clopidogrel" },
      { label: "Prasugrel", value: "Prasugrel" },
      { label: "Ticagrelor", value: "Ticagrelor" },
      { label: "Cangrelor", value: "Cangrelor" },
      { label: "Abciximab", value: "Abciximab" },
      { label: "Eptifibatide", value: "Eptifibatide" },
      { label: "Tirofiban", value: "Tirofiban" },
      { label: "Cilostazol", value: "Cilostazol" },
      { label: "Dipyridamole", value: "Dipyridamole" },
    ],
  },
  {
    id: "hx_coa",
    label: "anticoagulant 복용력 (hx_coa)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "hx_coa_type",
    label: "anticoagulant 종류 (hx_coa_type)",
    type: "checkbox",
    options: [
      { label: "Warfarin", value: "Warfarin" },
      { label: "Dabigatran", value: "Dabigatran" },
      { label: "Argatroban", value: "Argatroban" },
      { label: "Lepirudin", value: "Lepirudin" },
      { label: "Rivaroxaban", value: "Rivaroxaban" },
      { label: "Edoxaban", value: "Edoxaban" },
      { label: "Heparin", value: "Heparin" },
      { label: "Enoxaparin", value: "Enoxaparin" },
      { label: "Dalteparin", value: "Dalteparin" },
      { label: "Tinzaparin", value: "Tinzaparin" },
      { label: "Fondaparinux", value: "Fondaparinux" },
    ],
  },
  {
    id: "hx_alcohol",
    label: "음주력 (hx_alcohol)",
    type: "radio",
    options: [
      { label: "None", value: "None" },
      {
        label: "Infrequent : < 12 drinks/year",
        value: "Infrequent : < 12 drinks/year",
      },
      {
        label: "Light : ≥12 drinks/year and ≤3 drinks/week",
        value: "Light : ≥12 drinks/year and ≤3 drinks/week",
      },
      {
        label:
          "Moderate : >3 and ≤ 14 drinks/week(male), >3 and ≤ 7 drinks/week(Female)",
        value:
          "Moderate : >3 and ≤ 14 drinks/week(male), >3 and ≤ 7 drinks/week(Female)",
      },
      {
        label: "Heavy : >14 drinks/week (Male), >7 drinks/week (Female)",
        value: "Heavy : >14 drinks/week (Male), >7 drinks/week (Female)",
      },
    ],
  },
  {
    id: "hx_smok",
    label: "흡연력 (hx_smok)",
    type: "radio",
    options: [
      { label: "Never", value: "Never" },
      { label: "Current", value: "Current" },
      { label: "Ex-smoker", value: "Ex-smoker" },
    ],
  },

  {
    id: "hx_smok_pyrs",
    label: "흡연 갑년 (hx_smok_pyrs)",
    type: "text",
  },

  {
    id: "hx_pre_mrs",
    label: "병전 mRS 점수 (hx_pre_mrs)",
    type: "radio",
    options: [
      { label: "0 : No symptoms", value: "0 : No symptoms" },
      {
        label:
          "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
        value:
          "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
      },
      {
        label:
          "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
        value:
          "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
      },
      {
        label:
          "3 : Moderate disability. Requires some help, but able to walk unassisted.",
        value:
          "3 : Moderate disability. Requires some help, but able to walk unassisted.",
      },
      {
        label:
          "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted.",
        value:
          "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted.",
      },
      {
        label:
          "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent.",
        value:
          "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent.",
      },
      { label: "6 : Dead.", value: "6 : Dead." },
    ],
  },

  /* --------------------------------------------------
     SAH-specific fields (render only if index_injury == SAH)
  -------------------------------------------------- */

  {
    id: "sah_wfns",
    label: "WFNS score (sah_wfns)",
    type: "radio",
    options: [
      {
        label: "Grade 1: GCS score of 15 without focal deficit",
        value: "Grade 1: GCS score of 15 without focal deficit",
      },
      {
        label: "Grade 2: GCS score of 13 or 14 without focal deficit",
        value: "Grade 2: GCS score of 13 or 14 without focal deficit",
      },
      {
        label: "Grade 3: GCS score of 13 or 14 with focal deficit",
        value: "Grade 3: GCS score of 13 or 14 with focal deficit",
      },
      {
        label: "Grade 4: GCS score of 7-12",
        value: "Grade 4: GCS score of 7-12",
      },
      {
        label: "Grade 5: GCS score of 3-6",
        value: "Grade 5: GCS score of 3-6",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_modified_fisher",
    label: "modified Fisher scale (sah_modified_fisher)",
    type: "radio",
    options: [
      { label: "0 : no SAH or IVH", value: "0 : no SAH or IVH" },
      {
        label: "1 : SAH less than 1mm thick",
        value: "1 : SAH less than 1mm thick",
      },
      {
        label: "2 : SAH less than 1mm thick + IVH",
        value: "2 : SAH less than 1mm thick + IVH",
      },
      {
        label: "3 : SAH more than 1mm thick,+ no IVH",
        value: "3 : SAH more than 1mm thick,+ no IVH",
      },
      {
        label: "4 : SAH more than 1mm thick + IVH",
        value: "4 : SAH more than 1mm thick + IVH",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_hh",
    label: "Hunt Hess scale (sah_hh)",
    type: "radio",
    options: [
      {
        label:
          "1 : Mild Headache, Alert and Oriented, Minimal (if any) Nuchal Rigidity",
        value:
          "1 : Mild Headache, Alert and Oriented, Minimal (if any) Nuchal Rigidity",
      },
      {
        label:
          "2 : Full Nuchal Rigidity, Moderate-Severe Headache, Alert and Oriented, No Neuro Deficit (Besides CN Palsy)",
        value:
          "2 : Full Nuchal Rigidity, Moderate-Severe Headache, Alert and Oriented, No Neuro Deficit (Besides CN Palsy)",
      },
      {
        label: "3 : Lethargy or Confusion, Mild Focal Neurological Deficits",
        value: "3 : Lethargy or Confusion, Mild Focal Neurological Deficits",
      },
      {
        label: "4 : Stuporous, More Severe Focal Deficit",
        value: "4 : Stuporous, More Severe Focal Deficit",
      },
      {
        label:
          "5 : Comatose, showing signs of severe neurological impairment (ex: posturing)",
        value:
          "5 : Comatose, showing signs of severe neurological impairment (ex: posturing)",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysmal",
    label: "Ruptured aneurysm 여부 (sah_aneurysmal)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_others",
    label: "SAH의 기타 원인 (sah_others)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },

  {
    id: "sah_ich",
    label: "Ruptured aneurysm에 의한 ICH가 동반된 경우 (sah_ich)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_ich_location",
    label: "Ruptured aneurysm에 의한 ICH의 위치 (sah_ich_location)",
    type: "radio",
    options: [
      { label: "Frontal", value: "Frontal" },
      { label: "Bifrontal", value: "Bifrontal" },
      { label: "Frontotemporal", value: "Frontotemporal" },
      { label: "Temporal", value: "Temporal" },
      { label: "Other", value: "Other" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_ich_location_other",
    label: "Ruptured aneurysm에 의한 ICH의 기타 위치 (sah_ich_location_other)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_ich_volume",
    label: "Ruptured aneurysm에 의한 ICH의 volume (sah_ich_volume)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_location",
    label: "ruptured aneurysm의 location (aneurysm_location)",
    type: "radio",
    options: [
      { label: "Cavernous", value: "Cavernous" },
      { label: "Persistent trigeminal", value: "Persistent trigeminal" },
      { label: "Medial paraclinoid", value: "Medial paraclinoid" },
      { label: "Lateral paraclinoid", value: "Lateral paraclinoid" },
      { label: "Ophthalmic", value: "Ophthalmic" },
      { label: "Superior hypophyseal", value: "Superior hypophyseal" },
      { label: "Posterior communicating", value: "Posterior communicating" },
      { label: "Anterior choroidal", value: "Anterior choroidal" },
      {
        label: "Internal carotid artery bifurcation",
        value: "Internal carotid artery bifurcation",
      },
      {
        label: "Middle cerebral artery bifurcation",
        value: "Middle cerebral artery bifurcation",
      },
      { label: "Anterior communicating", value: "Anterior communicating" },
      { label: "Pericallosal", value: "Pericallosal" },
      {
        label: "Posterior inferior cerebellar artery",
        value: "Posterior inferior cerebellar artery",
      },
      { label: "Superior cerebellar", value: "Superior cerebellar" },
      { label: "Basilar apex", value: "Basilar apex" },
      { label: "Other", value: "Other" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_location_other",
    label: "ruptured aneurysm의 location_기타 (aneurysm_location_other)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_height",
    label: "aneurysm height (aneurysm_height)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
    detail:
      "동맥류의 높이를 mm 단위로 입력합니다. aneurysm_neck_max와 함께 aspect ratio 자동 계산에 사용됩니다.",
    calculationInput: true,
    affectsField: "aneurysm_aspect_ratio",
    unit: "mm",
  },
  {
    id: "aneurysm_width",
    label: "aneurysm width (aneurysm_width)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
    detail:
      "동맥류의 폭을 mm 단위로 입력합니다. aneurysm_neck_max와 함께 bottleneck factor 자동 계산에 사용됩니다.",
    calculationInput: true,
    affectsField: "aneurysm_bottleneck_factor",
    unit: "mm",
  },
  {
    id: "aneurysm_diameter",
    label: "aneurysm diameter (aneurysm_diameter)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_neck_max",
    label: "neck (aneurysm_neck_max)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
    detail:
      "동맥류 목(neck)의 최대 직경을 mm 단위로 입력합니다. height, width와 함께 aspect ratio 및 bottleneck factor 자동 계산에 사용됩니다.",
    calculationInput: true,
    affectsFields: ["aneurysm_aspect_ratio", "aneurysm_bottleneck_factor"],
    unit: "mm",
  },
  {
    id: "aneurysm_shape_pathology",
    label: "aneurysm shape/pathology (aneurysm_shape_pathology)",
    type: "radio",
    options: [
      { label: "Saccular", value: "Saccular" },
      { label: "Dissecting", value: "Dissecting" },
      { label: "Fusiform", value: "Fusiform" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_laterality",
    label: "aneurysm laterality (aneurysm_laterality)",
    type: "radio",
    options: [
      { label: "Left", value: "Left" },
      { label: "Right", value: "Right" },
      { label: "Midline", value: "Midline" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_aspect_ratio",
    label: "aspect ratio value (aneurysm_aspect_ratio)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
    detail:
      "동맥류의 종횡비로 자동 계산됩니다. 계산 공식: height / neck_max. 소수점 2자리까지 표시되며, neck이 0이거나 비어있으면 빈값으로 처리됩니다.",
    readonly: true,
    autoCalculated: true,
    calculationFormula: "aneurysm_height / aneurysm_neck_max",
    calculationInputs: ["aneurysm_height", "aneurysm_neck_max"],
  },
  {
    id: "aneurysm_morphology_type",
    label: "morphology type (aneurysm_morphology_type)",
    type: "radio",
    options: [
      { label: "Regular", value: "Regular" },
      {
        label: "Daughter-sac, multi-lobed aneurysm",
        value: "Daughter-sac, multi-lobed aneurysm",
      },
      { label: "Bleb", value: "Bleb" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "aneurysm_bottleneck_factor",
    label: "Bottleneck factor (aneurysm_bottleneck_factor)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
    detail:
      "동맥류의 병목 인자로 자동 계산됩니다. 계산 공식: width / neck_max. 소수점 2자리까지 표시되며, neck이 0이거나 비어있으면 빈값으로 처리됩니다.",
    readonly: true,
    autoCalculated: true,
    calculationFormula: "aneurysm_width / aneurysm_neck_max",
    calculationInputs: ["aneurysm_width", "aneurysm_neck_max"],
  },
  {
    id: "aneurysm_unruptured_number",
    label: "Number of UIA (aneurysm_unruptured_number)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg",
    label: "Status of surgical intervention (sah_aneurysm_surg)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Attempt failed", value: "Attempt failed" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg_type",
    label: "수술적 치료 종류 (sah_aneurysm_surg_type)",
    type: "radio",
    options: [
      { label: "Bypass", value: "Bypass" },
      { label: "Clipping", value: "Clipping" },
      { label: "Trapping alone", value: "Trapping alone" },
      { label: "Wrapping", value: "Wrapping" },
      { label: "Hunterian ligation alone", value: "Hunterian ligation alone" },
      { label: "Other", value: "Other" },
      { label: "None/attempted", value: "None/attempted" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg_other",
    label: "수술적 치료 종류_기타 (sah_aneurysm_surg_other)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg_start_dt",
    label: "수술 시작 시각 (sah_aneurysm_surg_start_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg_end_dt",
    label: "수술 종료 시각 (sah_aneurysm_surg_end_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg_comp",
    label: "수술적 치료 관련 중대한 합병증 (sah_aneurysm_surg_comp)",
    type: "radio",
    options: [
      { label: "None", value: "None" },
      {
        label: "Vessel compromise (significant stenosis > 50%, occlusion)",
        value: "Vessel compromise (significant stenosis > 50%, occlusion)",
      },
      { label: "Distal embolism", value: "Distal embolism" },
      { label: "Incomplete clipping", value: "Incomplete clipping" },
      {
        label:
          "Craniotomy related complication _ extradural or subdural hematoma",
        value:
          "Craniotomy related complication _ extradural or subdural hematoma",
      },
      { label: "Cranial nerve injury", value: "Cranial nerve injury" },
      {
        label: "Direct brain tissue injury",
        value: "Direct brain tissue injury",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_surg_comp_other",
    label: "수술적 치료 관련 중대한 합병증_기타 (sah_aneurysm_surg_comp_other)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo",
    label: "Status of endovascular intervention (sah_aneurysm_endo)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Attempt failed", value: "Attempt failed" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo_type",
    label: "혈관내 치료 종류 (sah_aneurysm_endo_type)",
    type: "radio",
    options: [
      { label: "Coil", value: "Coil" },
      {
        label: "Coil with balloon remodeling",
        value: "Coil with balloon remodeling",
      },
      { label: "Stent only", value: "Stent only" },
      { label: "Stent/coil", value: "Stent/coil" },
      { label: "Vessel occlusion", value: "Vessel occlusion" },
      { label: "Flow diverter", value: "Flow diverter" },
      { label: "Other", value: "Other" },
      { label: "None/attempted", value: "None/attempted" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo_type_other",
    label: "혈관내 치료 종류_기타 (sah_aneurysm_endo_type_other)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo_start_dt",
    label: "혈관내 치료 시작 시각 (sah_aneurysm_endo_start_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo_end_dt",
    label: "혈관내 치료 종료 시각 (sah_aneurysm_endo_end_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo_comp",
    label: "혈관내 치료 관련 중대한 합병증 (sah_aneurysm_endo_comp)",
    type: "checkbox",
    options: [
      { label: "None", value: "None" },
      {
        label: "Ischemia (thrombosis / vessel occlusion)",
        value: "ischemia (thrombosis / vessel occlusion)",
      },
      { label: "Procedural rupture", value: "procedural rupture" },
      { label: "Device migration", value: "device migration" },
      { label: "Others, Specify", value: "Others@ specify" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_aneurysm_endo_comp_others",
    label:
      "혈관내 치료 관련 중대한 합병증_기타 (sah_aneurysm_endo_comp_others)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_csf_diversion",
    label: "EVD 혹은 Lumbar drain 여부 (sah_csf_diversion)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "EVD", value: "EVD" },
      { label: "Lumbar drain", value: "Lumbar drain" },
      { label: "Both", value: "Both" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_csf_diversion_dt",
    label: "EVD 혹은 Lumbar drain 삽입 시각 (sah_csf_diversion_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_csf_removal_dt",
    label: "EVD 혹은 Lumbar drain 제거 시각 (sah_csf_removal_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_rebleeding",
    label: "Rebleeding 여부 (sah_rebleeding)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_rebleeding_dt",
    label: "Rebleeding 발생 일시 (sah_rebleeding_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_hcp_acute",
    label: "Acute hydrocephalus 여부 (sah_hcp_acute)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Indeterminate", value: "Indeterminate" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },

  {
    id: "tbi_injury_type",
    label: "TBI injury type (tbi_injury_type)",
    type: "radio",
    options: [
      { label: "Ground level fall (낙상)", value: "Ground level fall (낙상)" },
      {
        label: "Fall from height > 1 meter (추락)",
        value: "Fall from height > 1 meter (추락)",
      },
      { label: "Road traffic accident", value: "Road traffic accident" },
      { label: "Violence/Assault", value: "Violence/Assault" },
      { label: "Others, specify", value: "Others, specify" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_injury_type_others",
    label: "TBI injury type_기타 (tbi_injury_type_others)",
    type: "text",
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_iss_headneck",
    label: "Head and neck worst injury? (tbi_iss_headneck)",
    type: "radio",
    options: [
      { label: "0 : No Injury", value: "0 : No Injury" },
      {
        label: "1 : Minor- no treatment needed",
        value: "1 : Minor- no treatment needed",
      },
      {
        label: "2 : Moderate - requires only outpatient teatment",
        value: "2 : Moderate - requires only outpatient teatment",
      },
      {
        label: "3 : Serious - requires non-ICU hospital admission",
        value: "3 : Serious - requires non-ICU hospital admission",
      },
      {
        label: "4 : Severe - requires ICU observation and/or basic treatment",
        value: "4 : Severe - requires ICU observation and/or basic treatment",
      },
      {
        label:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
        value:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
      },
      {
        label: "6 : Unsurvivable - not survivable",
        value: "6 : Unsurvivable - not survivable",
      },
    ],
    conditions: 'index_injury === "TBI"',
    detail:
      "ISS Score 자동 계산에 사용되는 6개 신체 부위 중 하나입니다. 모든 ISS 관련 필드가 선택되면 상위 3개 점수의 제곱합으로 ISS Score가 자동 계산됩니다.",
    calculationInput: true,
    affectsField: "tbi_iss_score",
  },
  {
    id: "tbi_iss_face",
    label: "Face worst injury? (tbi_iss_face)",
    type: "radio",
    options: [
      { label: "0 : No Injury", value: "0 : No Injury" },
      {
        label: "1 : Minor- no treatment needed",
        value: "1 : Minor- no treatment needed",
      },
      {
        label: "2 : Moderate - requires only outpatient teatment",
        value: "2 : Moderate - requires only outpatient teatment",
      },
      {
        label: "3 : Serious - requires non-ICU hospital admission",
        value: "3 : Serious - requires non-ICU hospital admission",
      },
      {
        label: "4 : Severe - requires ICU observation and/or basic treatment",
        value: "4 : Severe - requires ICU observation and/or basic treatment",
      },
      {
        label:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
        value:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
      },
      {
        label: "6 : Unsurvivable - not survivable",
        value: "6 : Unsurvivable - not survivable",
      },
    ],
    conditions: 'index_injury === "TBI"',
    detail: "ISS Score 자동 계산에 사용되는 6개 신체 부위 중 하나입니다.",
    calculationInput: true,
    affectsField: "tbi_iss_score",
  },
  {
    id: "tbi_iss_chest",
    label: "Chest worst injury? (tbi_iss_chest)",
    type: "radio",
    options: [
      { label: "0 : No Injury", value: "0 : No Injury" },
      {
        label: "1 : Minor- no treatment needed",
        value: "1 : Minor- no treatment needed",
      },
      {
        label: "2 : Moderate - requires only outpatient teatment",
        value: "2 : Moderate - requires only outpatient teatment",
      },
      {
        label: "3 : Serious - requires non-ICU hospital admission",
        value: "3 : Serious - requires non-ICU hospital admission",
      },
      {
        label: "4 : Severe - requires ICU observation and/or basic treatment",
        value: "4 : Severe - requires ICU observation and/or basic treatment",
      },
      {
        label:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
        value:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
      },
      {
        label: "6 : Unsurvivable - not survivable",
        value: "6 : Unsurvivable - not survivable",
      },
    ],
    conditions: 'index_injury === "TBI"',
    detail: "ISS Score 자동 계산에 사용되는 6개 신체 부위 중 하나입니다.",
    calculationInput: true,
    affectsField: "tbi_iss_score",
  },
  {
    id: "tbi_iss_abdomen",
    label: "Abdomen worst injury? (tbi_iss_abdomen)",
    type: "radio",
    options: [
      { label: "0 : No Injury", value: "0 : No Injury" },
      {
        label: "1 : Minor- no treatment needed",
        value: "1 : Minor- no treatment needed",
      },
      {
        label: "2 : Moderate - requires only outpatient teatment",
        value: "2 : Moderate - requires only outpatient teatment",
      },
      {
        label: "3 : Serious - requires non-ICU hospital admission",
        value: "3 : Serious - requires non-ICU hospital admission",
      },
      {
        label: "4 : Severe - requires ICU observation and/or basic treatment",
        value: "4 : Severe - requires ICU observation and/or basic treatment",
      },
      {
        label:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
        value:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
      },
      {
        label: "6 : Unsurvivable - not survivable",
        value: "6 : Unsurvivable - not survivable",
      },
    ],
    conditions: 'index_injury === "TBI"',
    detail: "ISS Score 자동 계산에 사용되는 6개 신체 부위 중 하나입니다.",
    calculationInput: true,
    affectsField: "tbi_iss_score",
  },
  {
    id: "tbi_iss_external",
    label: "External worst injury? (tbi_iss_external)",
    type: "radio",
    options: [
      { label: "0 : No Injury", value: "0 : No Injury" },
      {
        label: "1 : Minor- no treatment needed",
        value: "1 : Minor- no treatment needed",
      },
      {
        label: "2 : Moderate - requires only outpatient teatment",
        value: "2 : Moderate - requires only outpatient teatment",
      },
      {
        label: "3 : Serious - requires non-ICU hospital admission",
        value: "3 : Serious - requires non-ICU hospital admission",
      },
      {
        label: "4 : Severe - requires ICU observation and/or basic treatment",
        value: "4 : Severe - requires ICU observation and/or basic treatment",
      },
      {
        label:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
        value:
          "5 : Critical - requires intubation, mechanical ventilation or vasopressors for blood pressure support",
      },
      {
        label: "6 : Unsurvivable - not survivable",
        value: "6 : Unsurvivable - not survivable",
      },
    ],
    conditions: 'index_injury === "TBI"',
    detail: "ISS Score 자동 계산에 사용되는 6개 신체 부위 중 하나입니다.",
    calculationInput: true,
    affectsField: "tbi_rotterdam",
  },
  {
    id: "tbi_fourth_vent_eff",
    label: "Ventricle - fourth shift effacement status (tbi_fourth_vent_eff)",
    type: "radio",
    options: [
      { label: "Absent", value: "Absent" },
      { label: "Present", value: "Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_contusion",
    label: "Contusion status (tbi_contusion)",
    type: "radio",
    options: [
      { label: "Absent", value: "Absent" },
      { label: "Present", value: "Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_ich",
    label: "Intracerebral hemorrhage indicator (tbi_ich)",
    type: "radio",
    options: [
      { label: "Absent", value: "Absent" },
      { label: "Present", value: "Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_ivh",
    label: "Intraventricular hemorrhage status (tbi_ivh)",
    type: "radio",
    options: [
      { label: "Absent", value: "0 : Absent" },
      { label: "Present", value: "1 : Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_acute_hydro",
    label: "Acute hydrocephalus 여부 (tbi_acute_hydro)",
    type: "radio",
    options: [
      { label: "Absent", value: "Absent" },
      { label: "Present", value: "Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_dai",
    label: "Diffuse axonal injury status (tbi_dai)",
    type: "radio",
    options: [
      { label: "Absent", value: "Absent" },
      { label: "Present", value: "Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_rotterdam",
    label: "rotterdam CT score (tbi_rotterdam)",
    type: "text",
    conditions: 'index_injury === "TBI"',
    detail:
      "4개 CT 소견을 기반으로 자동 계산됩니다. 계산 공식: 1 + 기저조(0-2) + 중선편위(0-1) + EDH(0-1) + 허혈성병변(0-1). 총 점수 범위: 1-6점. 모든 관련 필드 선택 시에만 자동 계산됩니다.",
    readonly: true,
    autoCalculated: true,
    calculationFormula: "1 + cistern + midline_shift + EDH + ischemia",
    calculationInputs: [
      "tbi_cistern_comp",
      "tbi_midline_shift",
      "tbi_edh",
      "tbi_isc_inf_hie",
    ],
  },
  {
    id: "tbi_isc_inf_hie",
    label:
      "Ischemia infarction hypoxic-ischemic injury status (tbi_isc_inf_hie)",
    type: "radio",
    options: [
      { label: "Absent", value: "Absent" },
      { label: "Present", value: "Present" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_isc_inf_hie_extent",
    label:
      "Ischemia infarction hypoxic-ischemic injury extent type (tbi_isc_inf_hie_extent)",
    type: "radio",
    options: [
      { label: "Focal", value: "Focal" },
      { label: "Lobar", value: "Lobar" },
      { label: "Multilobar", value: "Multilobar" },
      { label: "Hemispheric", value: "Hemispheric" },
      { label: "Bihemispheric", value: "Bihemispheric" },
      { label: "Posterior fossa", value: "Posterior fossa" },
      { label: "Global", value: "Global" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_txa",
    label: "Tranexamic acid 사용 여부 (tbi_txa)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_txa_dt",
    label: "Tranexamic acid 투약 시각 (tbi_txa_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "TBI"',
  },

  {
    id: "ich_ivh",
    label: "ICH 및 IVH (ich_ivh)",
    type: "radio",
    options: [
      { label: "ICH only", value: "ICH only" },
      { label: "IVH only", value: "IVH only" },
      { label: "ICH + IVH", value: "ICH + IVH" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_location",
    label: "ICH의 위치 (ich_location)",
    type: "checkbox",
    options: [
      {
        label: "Lobar / Right (Supratentorial)",
        value: "Lobar / Right (Supratentorial)",
      },
      {
        label: "Lobar / Left (Supratentorial)",
        value: "Lobar / Left (Supratentorial)",
      },
      {
        label: "Basal ganglia / Right (Supratentorial)",
        value: "Basal ganglia / Right (Supratentorial)",
      },
      {
        label: "Basal ganglia / Left (Supratentorial)",
        value: "Basal ganglia / Left (Supratentorial)",
      },
      {
        label: "Thalamus / Right (Supratentorial)",
        value: "Thalamus / Right (Supratentorial)",
      },
      {
        label: "Thalamus / Left (Supratentorial)",
        value: "Thalamus / Left (Supratentorial)",
      },
      {
        label: "Brainstem (Infratentorial)",
        value: "Brainstem (Infratentorial)",
      },
      {
        label: "Cerebellum (Infratentorial)",
        value: "Cerebellum (Infratentorial)",
      },
      { label: "Others", value: "Others" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_location_others",
    label: "ICH의 위치_others (ich_location_others)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_location_main",
    label: "ICH의 추정 발생 위치 (ich_location_main)",
    type: "radio",
    options: [
      { label: "Lobar", value: "Lobar" },
      { label: "Basal Ganglia", value: "Basal Ganglia" },
      { label: "Thalamus", value: "Thalamus" },
      { label: "Brainstem", value: "Brainstem" },
      { label: "Cerebellum", value: "Cerebellum" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_rt_temp",
    label: "Modified Graeb - Rt. Temporal tip (ivh_mgraeb_rt_temp)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=50%", value: "1 : <=50%" },
      { label: "50 - 100%", value: "2 : 50 - 100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
    detail:
      "Modified Graeb Scale 자동 계산에 사용되는 16개 IVH 관련 필드 중 하나입니다. basic 타입(0-2점)으로 분류됩니다.",
    calculationInput: true,
    affectsField: "ivh_mgraeb_score",
    graebType: "basic",
  },
  {
    id: "Ivh_mgraeb_rt_temp_exp",
    label:
      "Modified Graeb - Rt. Temporal tip expansion (ivh_mgraeb_rt_temp_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_rt_lateral",
    label: "Modified Graeb - Rt. Lateral ventricle (ivh_mgraeb_rt_lateral)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=25%", value: "1 : <=25%" },
      { label: "25 - 50%", value: "2 : 25 - 50%" },
      { label: "50 - 75%", value: "3 : 50 - 75%" },
      { label: "75-100%", value: "4 : 75-100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_rt_lateral_exp",
    label:
      "Modified Graeb - Rt. Lateral ventricle expansion (ivh_mgraeb_rt_lateral_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_rt_occip",
    label: "Modified Graeb - Rt. Occipital tip (ivh_mgraeb_rt_occip)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=50%", value: "1 : <=50%" },
      { label: "50 - 100%", value: "2 : 50 - 100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_rt_occip_exp",
    label:
      "Modified Graeb - Rt. Occipital tip expansion (ivh_mgraeb_rt_occip_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_lt_temp",
    label: "Modified Graeb - Lt. Temporal tip (ivh_mgraeb_lt_temp)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=50%", value: "1 : <=50%" },
      { label: "50 - 100%", value: "2 : 50 - 100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_lt_temp_exp",
    label:
      "Modified Graeb - Lt. Temporal tip expansion (ivh_mgraeb_lt_temp_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_lt_lateral",
    label: "Modified Graeb - Lt. Lateral ventricle (ivh_mgraeb_lt_lateral)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=25%", value: "1 : <=25%" },
      { label: "25 - 50%", value: "2 : 25 - 50%" },
      { label: "50 - 75%", value: "3 : 50 - 75%" },
      { label: "75-100%", value: "4 : 75-100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_lt_lateral_exp",
    label:
      "Modified Graeb - Lt. Lateral ventricle expansion (ivh_mgraeb_lt_lateral_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_lt_occip",
    label: "Modified Graeb - Lt. Occipital tip (ivh_mgraeb_lt_occip)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=50%", value: "1 : <=50%" },
      { label: "50 - 100%", value: "2 : 50 - 100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "Ivh_mgraeb_lt_occip_exp",
    label:
      "Modified Graeb - Lt. Occipital tip expansion (ivh_mgraeb_lt_occip_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ivh_mgraeb_3rd",
    label: "Modified Graeb - 3rd ventricle (ivh_mgraeb_3rd)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=50%", value: "1 : <=50%" },
      { label: "50 - 100%", value: "2 : 50 - 100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ivh_mgraeb_3rd_exp",
    label: "Modified Graeb - 3rd ventricle expansion (ivh_mgraeb_3rd_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ivh_mgraeb_4th",
    label: "Modified Graeb - 4th ventricle (ivh_mgraeb_4th)",
    type: "radio",
    options: [
      { label: "None", value: "0 : None" },
      { label: "<=50%", value: "1 : <=50%" },
      { label: "50 - 100%", value: "2 : 50 - 100%" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ivh_mgraeb_4th_exp",
    label: "Modified Graeb - 4th ventricle expansion (ivh_mgraeb_4th_exp)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Expanded", value: "1 : Expanded" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ivh_mgraeb_score",
    label: "Modifed Graeb scale (ivh_mgraeb_score)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
    detail:
      "16개 IVH 관련 필드의 점수를 합산하여 자동 계산됩니다. 필드 타입별 점수: basic(temporal/occipital tip, 3rd/4th ventricle) 0-2점, lateral(좌우 lateral ventricle) 0-4점, expansion(모든 *_exp 필드) 0-1점. 총 점수 범위: 0-30점. 모든 16개 필드 선택 시에만 자동 계산됩니다.",
    readonly: true,
    autoCalculated: true,
    calculationFormula:
      "Sum of 16 IVH field scores by type (basic + lateral + expansion)",
    calculationInputs: [
      "ivh_mgraeb_rt_temp",
      "ivh_mgraeb_rt_temp_exp",
      "ivh_mgraeb_rt_lateral",
      "ivh_mgraeb_rt_lateral_exp",
      "ivh_mgraeb_rt_occip",
      "ivh_mgraeb_rt_occip_exp",
      "ivh_mgraeb_lt_temp",
      "ivh_mgraeb_lt_temp_exp",
      "ivh_mgraeb_lt_lateral",
      "ivh_mgraeb_lt_lateral_exp",
      "ivh_mgraeb_lt_occip",
      "ivh_mgraeb_lt_occip_exp",
      "ivh_mgraeb_3rd",
      "ivh_mgraeb_3rd_exp",
      "ivh_mgraeb_4th",
      "ivh_mgraeb_4th_exp",
    ],
  },
  {
    id: "ich_ivh_hydro",
    label: "Acute hydrocephalus 여부 (ich_ivh_hydro)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_volume_abc",
    label: "ICH volume - ABC/2 (ich_volume_abc)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_cause",
    label: "ICH 및 IVH의 원인 (ich_ivh_cause)",
    type: "radio",
    options: [
      { label: "Spontaneous", value: "Spontaneous" },
      {
        label: "Arteriovenous malformation",
        value: "Arteriovenous malformation",
      },
      { label: "Tumor", value: "Tumor" },
      { label: "Moyamoya disease", value: "Moyamoya disease" },
      { label: "Trauma", value: "Trauma" },
      { label: "Ruptured aneurysm", value: "Ruptured aneurysm" },
      {
        label: "Thrombolytic agent (rt-PA)",
        value: "Thrombolytic agent (rt-PA)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_cause_others",
    label: "ICH 및 IVH의 원인_others (ich_ivh_cause_others)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_surgery",
    label: "수술적 치료 여부 (ich_ivh_surgery)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_surgery_name",
    label: "수술적 치료 종류 (ich_ivh_surgery_name)",
    type: "checkbox",
    options: [
      {
        label: "Decompressive craniectomy only",
        value: "Decompressive craniectomy only",
      },
      {
        label: "Decompressive craniectomy + hematoma evacuation",
        value: "Decompressive craniectomy + hematoma evacuation",
      },
      {
        label: "Craniotomy + hematoma evacuation",
        value: "Craniotomy + hematoma evacuation",
      },
      {
        label: "Endoscopic or stereotactic hematoma evacuation (aspiration)",
        value: "Endoscopic or stereotactic hematoma evacuation (aspiration)",
      },
      {
        label: "Intrahematoma catheter insertion",
        value: "Intrahematoma catheter insertion",
      },
      {
        label: "External ventricular drainage",
        value: "External ventricular drainage",
      },
      {
        label: "Intraventricular thrombolysis",
        value: "Intraventricular thrombolysis",
      },
      {
        label: "Intrahematoma thrombolysis",
        value: "Intrahematoma thrombolysis",
      },
      { label: "Other, specify", value: "Other@ specify" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_surgery_others",
    label: "수술적 치료 종류_기타 (ich_ivh_surgery_others)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_surgery_dt",
    label: "수술적 치료 시작 시각 (ich_ivh_surgery_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_midline_shift",
    label: "Midline shift supratentorial indicator (ich_ivh_midline_shift)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_midline_shift_mm",
    label: "midline shift (ich_ivh_midline_shift_mm)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_cistern_comp",
    label: "Cisternal compression status (ich_ivh_cistern_comp)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_ivh_fourth_vent_eff",
    label:
      "Ventricle - fourth shift effacement status (ich_ivh_fourth_vent_eff)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_score_gcs",
    label: "ICH score - GCS (ich_score_gcs)",
    type: "radio",
    options: [
      { label: "GCS 13-15", value: "0 : GCS 13-15" },
      { label: "GCS 5-12", value: "1 : GCS 5-12" },
      { label: "GCS 3-4", value: "2 : GCS 3-4" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
    detail:
      "ICH Score 자동 계산에 사용되는 5개 구성 요소 중 하나입니다. 모든 ICH Score 관련 필드 선택 시 자동 계산됩니다.",
    calculationInput: true,
    affectsField: "ich_score",
  },
  {
    id: "ich_score_ich",
    label: "ICH score - ICH volume (ich_score_ich)",
    type: "radio",
    options: [
      { label: "ICH volume < 30㎤", value: "0 : ICH volume < 30㎤" },
      { label: "ICH volume ≥ 30㎤", value: "1 : ICH volume ≥ 30㎤" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_score_ivh",
    label: "ICH score - IVH 유무 (ich_score_ivh)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_score_infratentorial",
    label:
      "ICH score - Infratentorial origin of ICH (ich_score_infratentorial)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_score_age",
    label: "ICH score - Age (ich_score_age)",
    type: "radio",
    options: [
      { label: "Age < 80", value: "0 : Age < 80" },
      { label: "Age ≥ 80", value: "1 : Age ≥ 80" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_score",
    label: "ICH score (ich_score)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
    detail:
      "5개 구성 요소를 기반으로 자동 계산됩니다. 계산 공식: GCS(0-2) + ICH volume(0-1) + IVH(0-1) + Infratentorial(0-1) + Age(0-1). 총 점수 범위: 0-6점. 모든 관련 필드 선택 시에만 자동 계산됩니다.",
    readonly: true,
    autoCalculated: true,
    calculationFormula: "GCS + ICH_volume + IVH + Infratentorial + Age",
    calculationInputs: [
      "ich_score_gcs",
      "ich_score_ich",
      "ich_score_ivh",
      "ich_score_infratentorial",
      "ich_score_age",
    ],
  },

  {
    id: "initial_status",
    label: "Completion status_1",
    type: "radio",
    options: [
      { label: "Not started", value: "Not started" },
      { label: "In process", value: "In process" },
      { label: "Complete", value: "Complete" },
    ],
  },

  // 2번째 페이지
  {
    id: "icu_adm_from",
    label: "ICU 입실 경로 (icu_adm_from)",
    type: "radio",
    options: [
      { label: "ER", value: "ER" },
      { label: "OR", value: "OR" },
      { label: "Ward", value: "Ward" },
      { label: "High dependency unit", value: "High dependency unit" },
      { label: "Other hospital", value: "Other hospital" },
    ],
    conditions: "",
  },
  {
    id: "icu_adm_dt",
    label: "ICU 입실 일시 (icu_adm_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "icu_adm_gcs_e",
    label: "ICU 입실시 GCS_E (icu_adm_gcs_e)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : To pain", value: "2 : To pain" },
      { label: "3 : To speech", value: "3 : To speech" },
      { label: "4 : Spontaneously", value: "4 : Spontaneously" },
      { label: "Untestable (swollen)", value: "0 : Untestable (swollen)" },
      { label: "Untestable (other)", value: "0 : Untestable (other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "icu_adm_gcs_v",
    label: "ICU 입실시 GCS_V (icu_adm_gcs_v)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      {
        label: "2 : Incomprehensible sound",
        value: "2 : Incomprehensible sound",
      },
      { label: "3 : Inappropriate words", value: "3 : Inappropriate words" },
      { label: "4 : Confused", value: "4 : Confused" },
      { label: "5 : Oriented", value: "5 : Oriented" },
      {
        label: "Untestable (tracheotomy/endotracheal tube)",
        value: "0 : Untestable (tracheotomy/endotracheal tube)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "icu_adm_gcs_m",
    label: "ICU 입실시 GCS_M (icu_adm_gcs_m)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : Abnormal extension", value: "2 : Abnormal extension" },
      { label: "3 : Abnormal flexion", value: "3 : Abnormal flexion" },
      {
        label: "4 : Normal flexion/withdrawal",
        value: "4 : Normal flexion/withdrawal",
      },
      { label: "5 : Localizes to pain", value: "5 : Localizes to pain" },
      { label: "6 : Obeys command", value: "6 : Obeys command" },
      {
        label: "Untestable (Deep sedation/paralyzed)",
        value: "0 : Untestable (Deep sedation/paralyzed)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "icu_adm_gcs_total",
    label: "ICU 입실시 GCS 합계 (icu_adm_gcs_total)",
    type: "text",
    conditions: "",
  },
  {
    id: "icu_adm_gcs_confounder",
    label:
      "Glasgow Coma Scale (GCS) - confounders type (icu_adm_gcs_confounder)",
    type: "radio",
    options: [
      { label: "No sedation or paralysis", value: "No sedation or paralysis" },
      { label: "Sedated", value: "Sedated" },
      { label: "Paralyzed", value: "Paralyzed" },
      {
        label: "Temporary stop of sedation/paralysis",
        value: "Temporary stop of sedation/paralysis",
      },
      {
        label: "Reversal of sedation/paralysis",
        value: "Reversal of sedation/paralysis",
      },
      {
        label: "Active reversal (pharmacologic) of sedation/paralysis",
        value: "Active reversal (pharmacologic) of sedation/paralysis",
      },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "icp_monitor",
    label: "ICP monitor 삽입 여부 (icp_monitor)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "icp_device",
    label: "ICP monitor 종류 (icp_device)",
    type: "radio",
    options: [
      { label: "Ventricular", value: "Ventricular" },
      { label: "Parenchymal", value: "Parenchymal" },
      { label: "Epidural / Subdural", value: "Epidural / Subdural" },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "icp_ins_dt",
    label: "ICP monitor 삽입 일시 (icp_ins_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "icp_removal_dt",
    label: "ICP monitor 제거 일시 (icp_removal_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "icp_reason",
    label: "Reasons for monitoring ICP (icp_reason)",
    type: "checkbox",
    options: [
      { label: "Guideline criteria", value: "Guideline criteria" },
      {
        label: "Radiological signs raised ICP",
        value: "Radiological signs raised ICP",
      },
      {
        label: "Clinical suspicion raised ICP",
        value: "Clinical suspicion raised ICP",
      },
      {
        label:
          "Anaesthesia or mechanical ventilation required for extracranial injuries",
        value:
          "Anaesthesia or mechanical ventilation required for extracranial injuries",
      },
      {
        label: "To inform surgical indication for mass lesion",
        value: "To inform surgical indication for mass lesion",
      },
      { label: "Other, specify", value: "Other@ specify" },
    ],
    conditions: "",
  },
  {
    id: "icp_reason_other",
    label: "Other, please specify (icp_reason_other)",
    type: "text",
    conditions: "",
  },
  {
    id: "icp_controlled",
    label: "ICP control 여부 (icp_controlled)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes, controlled", value: "Yes, controlled" },
      { label: "Yes, refractory", value: "Yes, refractory" },
    ],
    conditions: "",
  },
  {
    id: "icp_problems",
    label: "Problems in ICP monitoring (icp_problems)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "icp_problems_detail",
    label: "Explain ICP problems (icp_problems_detail)",
    type: "radio",
    options: [
      {
        label: "Accidental catheter removal",
        value: "Accidental catheter removal",
      },
      {
        label: "Catheter obstruction/failure",
        value: "Catheter obstruction/failure",
      },
      {
        label: "Suspicion of inaccurate measurement",
        value: "Suspicion of inaccurate measurement",
      },
    ],
    conditions: "",
  },
  {
    id: "icp_cath_rev",
    label: "ICP catheter revised (icp_cath_rev)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "icp_cath_rev_dt",
    label: "Date catheter revised (icp_cath_rev_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "icp_stop",
    label: "Stop of ICPmonitoring (icp_stop)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "icp_duration",
    label: "ICP monitor duration (icp_duration)",
    type: "text",
    conditions: "",
  },
  {
    id: "icp_stop_reason",
    label: "ICP monitoring 중단 이유 (icp_stop_reason)",
    type: "radio",
    options: [
      { label: "Clinically improved", value: "Clinically improved" },
      { label: "ICP stable and < 20 mmHg", value: "ICP stable and < 20 mmHg" },
      { label: "Monitor/catheter failure", value: "Monitor/catheter failure" },
      {
        label: "Patient considered unsalvageable",
        value: "Patient considered unsalvageable",
      },
      { label: "Patient died", value: "Patient died" },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "icp_stop_reason_others",
    label: "ICP monitoring 중단 이유_기타 (icp_stop_reason_others)",
    type: "text",
    conditions: "",
  },
  {
    id: "ttm",
    label: "TTM 적용 여부 (ttm)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "ttm_start_dt",
    label: "TTM 시작 시각 (ttm_start_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "ttm_end_dt",
    label: "TTM 종료 시각 (ttm_end_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "ttm_duration",
    label: "TTM 적용 기간 (ttm_duration)",
    type: "text",
    conditions: "",
  },
  {
    id: "dvt_ppx_pharm",
    label: "Pharmacologic DVT prophylaxis 여부 (dvt_ppx_pharm)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "dvt_ppx_pharm_start_d",
    label: "Pharmacologic DVT prophylaxis 시작 일자 (dvt_ppx_pharm_start_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "dvt_ppx_pharm_stop_d",
    label: "Pharmacologic DVT prophylaxis 종료 일자 (dvt_ppx_pharm_stop_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "dvt_ppx_pharm_ongoing",
    label: "작성 시점에서 계속 사용하고 있는 경우 (dvt_ppx_pharm_ongoing)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "dvt_ppx_pharm_type",
    label: "Type of pharmacologic prophylaxis (dvt_ppx_pharm_type)",
    type: "radio",
    options: [
      { label: "Heparin", value: "Heparin" },
      {
        label: "Low molecular weight Heparin",
        value: "Low molecular weight Heparin",
      },
      { label: "DOAC", value: "DOAC" },
    ],
    conditions: "",
  },
  {
    id: "dvt_ppx_mech",
    label: "Mechanical DVT prophylaxis 여부 (dvt_ppx_mech)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "dvt_ppx_mech_start_d",
    label: "Mechanical DVT prophylaxis 시작 일자 (dvt_ppx_mech_start_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "dvt_ppx_mech_stop_d",
    label: "Mechanical DVT prophylaxis 종료 일자 (dvt_ppx_mech_stop_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "dvt_ppx_mech_type",
    label: "Type of mechanical prophylaxis (dvt_ppx_mech_type)",
    type: "radio",
    options: [
      {
        label: "Intermittent pneumatic compression",
        value: "Intermittent pneumatic compression",
      },
      { label: "Anti-embolic stocking", value: "Anti-embolic stocking" },
      { label: "Others", value: "Others" },
    ],
    conditions: "",
  },
  {
    id: "dvt_ppx_mech_ongoing",
    label: "작성 시점에서 계속 사용하고 있는 경우 (dvt_ppx_mech_ongoing)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "nutri_parenteral",
    label: "정맥영양 여부 (nutri_parenteral)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "nutri_parenteral_start_d",
    label: "정맥영양 시작 시각 (nutri_parenteral_start_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "nutri_parenteral_stop_d",
    label: "정맥영양 종료 시각 (nutri_parenteral_stop_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "nutri_enteral",
    label: "장관영양 여부 (nutri_enteral)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "nutri_enteral_start_d",
    label: "장관영양 시작 시각 (nutri_enteral_start_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "nutri_enteral_stop_d",
    label: "장관영양 종료 시각 (nutri_enteral_stop_d)",
    type: "date",
    conditions: "",
  },
  {
    id: "nutri_enteral_route",
    label: "장관영양 경로 (nutri_enteral_route)",
    type: "radio",
    options: [
      { label: "Nasogastric tube", value: "Nasogastric tube" },
      { label: "Transpyloric tube", value: "Transpyloric tube" },
      { label: "Gastrostomy", value: "Gastrostomy" },
      { label: "Oral", value: "Oral" },
    ],
    conditions: "",
  },
  {
    id: "intu",
    label: "기관삽관 여부 (intu)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "intu_start_dt",
    label: "기관삽관 시작 시각 (intu_start_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "intu_stop_dt",
    label: "기관삽관 종료 시각 (intu_stop_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "intu_stop_reason",
    label: "기관삽관 종료 이유 (intu_stop_reason)",
    type: "radio",
    options: [
      { label: "Respiratory stable", value: "Respiratory stable" },
      { label: "Accidental", value: "Accidental" },
      { label: "Withdrawal of care", value: "Withdrawal of care" },
    ],
    conditions: "",
  },
  {
    id: "reintu",
    label: "발관 후 재삽관 여부 (reintu)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "reintu_dt",
    label: "재삽관 시각 (reintu_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "reintu_reason",
    label: "인공호흡기 이탈 후 재개 이유 (remv_reason)",
    type: "radio",
    options: [
      { label: "Respiratory failure", value: "Respiratory failure" },
      { label: "Neurologic deterioration", value: "Neurologic deterioration" },
      {
        label: "Spontaneous hyperventilation",
        value: "Spontaneous hyperventilation",
      },
      { label: "Sepsis", value: "Sepsis" },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "reintu_reason_other",
    label: "재삽관 이유_기타 (reintu_reason_other)",
    type: "text",
    conditions: "",
  },
  {
    id: "mv",
    label: "인공호흡기 사용 여부 (mv)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "mv_start_dt",
    label: "인공호흡기 시작 시각 (mv_start_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "mv_stop_dt",
    label: "인공호흡기 종료 시각 (mv_stop_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "remv",
    label: "인공호흡기 이탈 후 재개 여부 (remv)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "remv_start_dt",
    label: "인공호흡기 이탈 후 재개 시각 (remv_start_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "remv_reason",
    label: "인공호흡기 이탈 후 재개 이유 (remv_reason)",
    type: "radio",
    options: [
      { label: "Respiratory failure", value: "Respiratory failure" },
      { label: "Neurologic deterioration", value: "Neurologic deterioration" },
      {
        label: "Spontaneous hyperventilation",
        value: "Spontaneous hyperventilation",
      },
      { label: "Sepsis", value: "Sepsis" },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "remv_reason_other",
    label: "인공호흡기 이탈 후 재개 이유_기타 (remv_reason_other)",
    type: "text",
    conditions: "",
  },
  {
    id: "trach",
    label: "기관절개 여부 (trach)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "trach_reason",
    label: "기관절개 이유 (trach_reason)",
    type: "radio",
    options: [
      {
        label:
          "Expected long duration of mechanical ventilation because of severe neurological damages",
        value:
          "Expected long duration of mechanical ventilation because of severe neurological damages",
      },
      { label: "Extubation failure", value: "Extubation failure" },
      { label: "Neurologic impairment", value: "Neurologic impairment" },
      { label: "Airway failure", value: "Airway failure" },
      {
        label: "Severe face and/or neck trauma",
        value: "Severe face and/or neck trauma",
      },
      {
        label: "Chronic respiratory disease",
        value: "Chronic respiratory disease",
      },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "trach_reason_other",
    label: "기관절개 이유_기타 (trach_reason_other)",
    type: "text",
    conditions: "",
  },
  {
    id: "trach_start_d",
    label: "기관절개 시작 일자 (trach_start_d)",
    type: "date",
    conditions: "",
  },

  {
    id: "icu_dis_dt",
    label: "ICU 퇴실 일시 (icu_dis_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "icu_dis_status",
    label: "ICU 퇴실시 생존 여부 (icu_dis_status)",
    type: "radio",
    options: [
      { label: "Alive", value: "Alive" },
      { label: "Dead", value: "Dead" },
    ],
    conditions: "",
  },
  {
    id: "icu_dis_to",
    label: "ICU 퇴실 후 장소 (icu_dis_to)",
    type: "radio",
    options: [
      { label: "General ward", value: "General ward" },
      { label: "Other ICU", value: "Other ICU" },
      {
        label: "Other hospital (2차병원 이상)",
        value: "Other hospital (2차병원 이상)",
      },
      { label: "Home", value: "Home" },
      {
        label: "Nursing home (요양재활병원/요양원)",
        value: "Nursing home (요양재활병원/요양원)",
      },
      {
        label: "Step down/high care unit (SubICU)",
        value: "Step down/high care unit (SubICU)",
      },
      { label: "Unknown", value: "Unknown" },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "icu_dis_gcs_e",
    label: "ICU 퇴실 직전 GCS_E (icu_dis_gcs_e)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : To pain", value: "2 : To pain" },
      { label: "3 : To speech", value: "3 : To speech" },
      { label: "4 : Spontaneously", value: "4 : Spontaneously" },
      { label: "Untestable (swollen)", value: "0 : Untestable (swollen)" },
      { label: "Untestable (other)", value: "0 : Untestable (other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "icu_dis_gcs_v",
    label: "ICU 퇴실 직전 GCS_V (icu_dis_gcs_v)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      {
        label: "2 : Incomprehensible sound",
        value: "2 : Incomprehensible sound",
      },
      { label: "3 : Inappropriate words", value: "3 : Inappropriate words" },
      { label: "4 : Confused", value: "4 : Confused" },
      { label: "5 : Oriented", value: "5 : Oriented" },
      {
        label: "Untestable (tracheotomy/endotracheal tube)",
        value: "0 : Untestable (tracheotomy/endotracheal tube)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "icu_dis_gcs_m",
    label: "ICU 퇴실 직전 GCS_M (icu_dis_gcs_m)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : Abnormal extension", value: "2 : Abnormal extension" },
      { label: "3 : Abnormal flexion", value: "3 : Abnormal flexion" },
      {
        label: "4 : Normal flexion/withdrawal",
        value: "4 : Normal flexion/withdrawal",
      },
      { label: "5 : Localizes to pain", value: "5 : Localizes to pain" },
      { label: "6 : Obeys command", value: "6 : Obeys command" },
      {
        label: "Untestable (Deep sedation/paralyzed)",
        value: "0 : Untestable (Deep sedation/paralyzed)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "icu_dis_gcs_confounder",
    label:
      "Glasgow Coma Scale (GCS) - confounders type (icu_dis_gcs_confounder)",
    type: "radio",
    options: [
      { label: "No sedation or paralysis", value: "No sedation or paralysis" },
      { label: "Sedated", value: "Sedated" },
      { label: "Paralyzed", value: "Paralyzed" },
      {
        label: "Temporary stop of sedation/paralysis",
        value: "Temporary stop of sedation/paralysis",
      },
      {
        label: "Reversal of sedation/paralysis",
        value: "Reversal of sedation/paralysis",
      },
      {
        label: "Active reversal (pharmacologic) of sedation/paralysis",
        value: "Active reversal (pharmacologic) of sedation/paralysis",
      },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "icu_dis_gcs_total",
    label: "ICU 퇴실 직전 GCS 합계 (icu_dis_gcs_total)",
    type: "text",
    conditions: "",
  },
  {
    id: "icu_status",
    label: "Completion status_2",
    type: "radio",
    options: [
      { label: "Not started", value: "Not started" },
      { label: "In process", value: "In process" },
      { label: "Complete", value: "Complete" },
    ],
    conditions: "",
  },

  // Daily 섹션을 위해 재상요이 되는 필드들

  {
    id: "d(n)_location",
    label: "Daily 작성시 환자의 위치 (d(n)_location)",
    type: "radio",
    options: [
      { label: "ICU", value: "ICU" },
      { label: "Sub-ICU/Stroke Unit", value: "Sub-ICU/Stroke Unit" },
      { label: "Ward", value: "Ward" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_dt",
    label: "time of worst GCS (d(n)_gcs_worst_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_asscond",
    label: "Worst GCS Assessment conditions (d(n)_gcs_worst_asscond)",
    type: "radio",
    options: [
      { label: "No sedation or paralysis", value: "No sedation or paralysis" },
      { label: "Sedated", value: "Sedated" },
      { label: "Paralyzed", value: "Paralyzed" },
      {
        label: "Temporary stop of sedation/paralysis",
        value: "Temporary stop of sedation/paralysis",
      },
      {
        label: "Reversal of sedation/paralysis",
        value: "Reversal of sedation/paralysis",
      },
      {
        label: "Active reversal (pharmacologic) of sedation/paralysis",
        value: "Active reversal (pharmacologic) of sedation/paralysis",
      },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_change24h",
    label: "Worst GCS Change over past 24 hours (d(n)_gcs_worst_change24h)",
    type: "radio",
    options: [
      { label: "No change", value: "No change" },
      { label: "Improving", value: "Improving" },
      { label: "Episode of deterioration", value: "Episode of deterioration" },
      { label: "Sustained deterioration", value: "Sustained deterioration" },
      { label: "Fluctuating", value: "Fluctuating" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_change24h_cause",
    label: "Cause of change (d(n)_gcs_worst_change24h_cause)",
    type: "radio",
    options: [
      { label: "Mainly intracranial", value: "Mainly intracranial" },
      { label: "Mainly extracranial", value: "Mainly extracranial" },
      { label: "Both to an equal extent", value: "Both to an equal extent" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_e",
    label: "Worst GCS_e (d(n)_gcs_worst_e)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : To pain", value: "2 : To pain" },
      { label: "3 : To speech", value: "3 : To speech" },
      { label: "4 : Spontaneously", value: "4 : Spontaneously" },
      { label: "Untestable (swollen)", value: "0 : Untestable (swollen)" },
      { label: "Untestable (other)", value: "0 : Untestable (other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_v",
    label: "Worst GCS_v (d(n)_gcs_worst_v)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      {
        label: "2 : Incomprehensible sound",
        value: "2 : Incomprehensible sound",
      },
      { label: "3 : Inappropriate words", value: "3 : Inappropriate words" },
      { label: "4 : Confused", value: "4 : Confused" },
      { label: "5 : Oriented", value: "5 : Oriented" },
      {
        label: "Untestable (tracheotomy/endotracheal tube)",
        value: "0 : Untestable (tracheotomy/endotracheal tube)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_m",
    label: "Worst GCS_m (d(n)_gcs_worst_m)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : Abnormal extension", value: "2 : Abnormal extension" },
      { label: "3 : Abnormal flexion", value: "3 : Abnormal flexion" },
      {
        label: "4 : Normal flexion/withdrawal",
        value: "4 : Normal flexion/withdrawal",
      },
      { label: "5 : Localizes to pain", value: "5 : Localizes to pain" },
      { label: "6 : Obeys command", value: "6 : Obeys command" },
      {
        label: "Untestable (Deep sedation/paralyzed)",
        value: "0 : Untestable (Deep sedation/paralyzed)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_worst_total",
    label: "Worst GCS_total (d(n)_gcs_worst_total)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_sym",
    label: "Worst pupil_symmetry (d(n)_pupil_worst_sym)",
    type: "radio",
    options: [
      { label: "Equal", value: "Equal" },
      { label: "Unequal R>L", value: "Unequal R>L" },
      { label: "Unequal L>R", value: "Unequal L>R" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_lr_lt",
    label: "Worst pupil_reflex_left (d(n)_pupil_worst_lr_lt)",
    type: "radio",
    options: [
      { label: "+ (Brisk)", value: "+ (Brisk)" },
      { label: "+ (Sluggish)", value: "+ (Sluggish)" },
      { label: "- (Negative)", value: "- (Negative)" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_size_lt",
    label: "Worst pupil_size_left (d(n)_pupil_worst_size_lt)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_unknown_lt",
    label: "Worst pupil_reflex_unknown_left (d(n)_pupil_worst_unknown_lt)",
    type: "radio",
    options: [
      { label: "Untestable", value: "Untestable" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_lr_rt",
    label: "Worst pupil_reflex_right (d(n)_pupil_worst_lr_rt)",
    type: "radio",
    options: [
      { label: "+ (Brisk)", value: "+ (Brisk)" },
      { label: "+ (Sluggish)", value: "+ (Sluggish)" },
      { label: "- (Negative)", value: "- (Negative)" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_size_rt",
    label: "Worst pupil_size_right (d(n)_pupil_worst_size_rt)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_pupil_worst_unknown_rt",
    label: "Worst pupil_reflex_unknown_right (d(n)_pupil_worst_unknown_rt)",
    type: "radio",
    options: [
      { label: "Untestable", value: "Untestable" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best",
    label: "Worst GCS same as best GCS? (d(n)_gcs_best)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_dt",
    label: "time of best GCS (d(n)_gcs_best_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_asscond",
    label: "Best GCS Assessment conditions (d(n)_gcs_best_asscond)",
    type: "radio",
    options: [
      { label: "No sedation or paralysis", value: "No sedation or paralysis" },
      { label: "Sedated", value: "Sedated" },
      { label: "Paralyzed", value: "Paralyzed" },
      {
        label: "Temporary stop of sedation/paralysis",
        value: "Temporary stop of sedation/paralysis",
      },
      {
        label: "Reversal of sedation/paralysis",
        value: "Reversal of sedation/paralysis",
      },
      {
        label: "Active reversal (pharmacologic) of sedation/paralysis",
        value: "Active reversal (pharmacologic) of sedation/paralysis",
      },
      { label: "Other", value: "Other" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_change24h",
    label: "GCS Change over past 24 hours (d(n)_gcs_best_change24h)",
    type: "radio",
    options: [
      { label: "No change", value: "No change" },
      { label: "Improving", value: "Improving" },
      { label: "Episode of deterioration", value: "Episode of deterioration" },
      { label: "Sustained deterioration", value: "Sustained deterioration" },
      { label: "Fluctuating", value: "Fluctuating" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_change24h_cause",
    label: "Cause of change (d(n)_gcs_best_change24h_cause)",
    type: "radio",
    options: [
      { label: "Mainly intracranial", value: "Mainly intracranial" },
      { label: "Mainly extracranial", value: "Mainly extracranial" },
      { label: "Both to an equal extent", value: "Both to an equal extent" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_e",
    label: "Best GCS_e (d(n)_gcs_best_e)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : To pain", value: "2 : To pain" },
      { label: "3 : To speech", value: "3 : To speech" },
      { label: "4 : Spontaneously", value: "4 : Spontaneously" },
      { label: "Untestable (swollen)", value: "0 : Untestable (swollen)" },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_v",
    label: "Best GCS_v (d(n)_gcs_best_v)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      {
        label: "2 : Incomprehensible sound",
        value: "2 : Incomprehensible sound",
      },
      { label: "3 : Inappropriate words", value: "3 : Inappropriate words" },
      { label: "4 : Confused", value: "4 : Confused" },
      { label: "5 : Oriented", value: "5 : Oriented" },
      {
        label: "Untestable (tracheotomy/endotracheal tube)",
        value: "0 : Untestable (tracheotomy/endotracheal tube)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_m",
    label: "Best GCS_m (d(n)_gcs_best_m)",
    type: "radio",
    options: [
      { label: "1 : None", value: "1 : None" },
      { label: "2 : Abnormal extension", value: "2 : Abnormal extension" },
      { label: "3 : Abnormal flexion", value: "3 : Abnormal flexion" },
      {
        label: "4 : Normal flexion/withdrawal",
        value: "4 : Normal flexion/withdrawal",
      },
      { label: "5 : Localizes to pain", value: "5 : Localizes to pain" },
      { label: "6 : Obeys command", value: "6 : Obeys command" },
      {
        label: "Untestable (Deep sedation/paralyzed)",
        value: "0 : Untestable (Deep sedation/paralyzed)",
      },
      { label: "Untestable (other)", value: "0 : Untestable (Other)" },
      { label: "Unknown", value: "0 : Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_gcs_best_total",
    label: "Best GCS_total (d(n)_gcs_best_total)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_sym",
    label: "Best pupil_symmetry (d(n)_pupil_best_sym)",
    type: "radio",
    options: [
      { label: "Equal", value: "Equal" },
      { label: "Unequal R>L", value: "Unequal R>L" },
      { label: "Unequal L>R", value: "Unequal L>R" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_lr_lt",
    label: "Best pupil_reflex_left (d(n)_pupil_best_lr_lt)",
    type: "radio",
    options: [
      { label: "+ (Brisk)", value: "+ (Brisk)" },
      { label: "+ (Sluggish)", value: "+ (Sluggish)" },
      { label: "- (Negative)", value: "- (Negative)" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_size_lt",
    label: "Best pupil_size_left (d(n)_pupil_best_size_lt)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_unknown_lt",
    label: "Best pupil_reflex_unknown_left (d(n)_pupil_best_unknown_lt)",
    type: "radio",
    options: [
      { label: "Untestable", value: "Untestable" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_lr_rt",
    label: "Best pupil_reflex_right (d(n)_pupil_best_lr_rt)",
    type: "radio",
    options: [
      { label: "+ (Brisk)", value: "+ (Brisk)" },
      { label: "+ (Sluggish)", value: "+ (Sluggish)" },
      { label: "- (Negative)", value: "- (Negative)" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_size_rt",
    label: "Best pupil_size_right (d(n)_pupil_best_size_rt)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_pupil_best_unknown_rt",
    label: "Best pupil_reflex_unknown_right (d(n)_pupil_best_unknown_rt)",
    type: "radio",
    options: [
      { label: "Untestable", value: "Untestable" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_neuroworse",
    label: "Neurological worsening 여부 (d(n)_neuroworse)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_neuroworse_type",
    label: "Neurological worsening 의 종류 (d(n)_neuroworse_type)",
    type: "checkbox",
    options: [
      {
        label: "GCS total 2점 이상 악화될 경우",
        value: "GCS total 2점 이상 악화될 경우",
      },
      {
        label: "Development of pupillary abnormalities",
        value: "Development of pupillary abnormalities",
      },
      {
        label: "Other neurological and/or CT deterioration",
        value: "Other neurological and/or CT deterioration",
      },
    ],
    conditions: "",
  },
  {
    id: "d(n)_neuroworse_action",
    label: "Neurological worsening 의 대처 (d(n)_neuroworse_action)",
    type: "checkbox",
    options: [
      { label: "None", value: "None" },
      { label: "Unscheduled CT scan", value: "Unscheduled CT scan" },
      {
        label: "Change in medical therapy",
        value: "Change in medical therapy",
      },
      { label: "Surgical intervention", value: "Surgical intervention" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_dt",
    label: "Therapeutic Intensity Level (TIL) 체크 일시 (d(n)_til_dt)",
    type: "datetime-local",
    conditions: "",
  },
  {
    id: "d(n)_til_complete",
    label: "Form Completion Status (d(n)_til_complete)",
    type: "radio",
    options: [
      { label: "Not Started", value: "Not Started" },
      { label: "In Process", value: "In Process" },
      { label: "Complete", value: "Complete" },
      { label: "Queries Outstanding", value: "Queries Outstanding" },
      { label: "Not Performed", value: "Not Performed" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_position",
    label: "Head elevation for ICP control (d(n)_til_position)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_position_flat",
    label: "Nursed flat (180°) for CPP management (d(n)_til_position_flat)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_sedation",
    label:
      "Sedation (low dose as required for mechanical ventilation) (d(n)_til_sedation)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_sedation_higher",
    label:
      "Higher dose sedation for ICP control (not aiming for burst supression) (d(n)_til_sedation_higher)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_sedation_suppression",
    label:
      "Metabolic suppression for ICP control with high dose barbiturates or propofol (d(n)_til_sedation_suppression)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_sedation_nmb",
    label: "Neuromuscular blockade (paralysis) (d(n)_til_sedation_nmb)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_csfdrain",
    label: "CSF Drainage (d(n)_til_csfdrain)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_csfdrainvol",
    label: "Volume drained (ml) (d(n)_til_csfdrainvol)",
    type: "text",
    conditions: "",
  },
  {
    id: "d(n)_til_fluidloading",
    label:
      "Fluid loading for maintenance of cerebral perfusion (d(n)_til_fluidloading)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_vasopressor",
    label:
      "Vasopressor therapy required for management of cerebral perfusion (d(n)_til_vasopressor)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_hyperventilation",
    label:
      "Mild hypocapnia for ICP control [PaCO2 ≤35 and < 40] (d(n)_til_hyperventilation)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_hyperventilation_mod",
    label:
      "Moderate hypocapnia for ICP control [PaCO2 ≤30 and < 35] (d(n)_til_hyperventilation_mod)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_hyperventilation_intense",
    label:
      "Intensive hypocapnia for ICP control [PaCO2 (< 30 mmHg)] (d(n)_til_hyperventilation_intense)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_osm_mnt_low",
    label:
      "Hyperosmolar therapy with mannitol up to 2 g/kg/24 hours (d(n)_til_osm_mnt_low)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_osm_hts_low",
    label:
      "Hyperosmolar therapy with hypertonic saline up to 0.3 g/kg/24 hours (d(n)_til_osm_hts_low)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_osm_mnt_high",
    label:
      "Hyperosmolar therapy with mannitol > 2 g/kg/24 hours (d(n)_til_osm_mnt_high)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_osm_hts_high",
    label:
      "Hyperosmolar therapy with hypertonic saline > 0.3 g/kg/24 hours (d(n)_til_osm_hts_high)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_fever",
    label:
      "Treatment of fever (temperature > 38℃) or spontaneous hypothermia (temperature < 34.5℃) (d(n)_til_fever)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_ttm_mild",
    label:
      "Mild hypothermia for ICP control with a lower limit of 35°C (d(n)_til_ttm_mild)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_ttm_moderate",
    label: "Hypothermia below 35°C (d(n)_til_ttm_moderate)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_icp_surgery",
    label:
      "Intracranial operation for progressive mass lesion, not scheduled on admission (d(n)_til_icp_surgery)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_icp_decomcrani",
    label: "Decompressive craniectomy (d(n)_til_icp_decomcrani)",
    type: "radio",
    options: [
      { label: "No", value: "0 : No" },
      { label: "Yes", value: "1 : Yes" },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_change_reason",
    label:
      "Reason for change in treatment over this day (d(n)_til_change_reason)",
    type: "radio",
    options: [
      { label: "No change", value: "No change" },
      {
        label: "Intensified: Clinical deterioration",
        value: "Intensified: Clinical deterioration",
      },
      {
        label: "Intensified:Suspicion of increased of ICP (not measured)",
        value: "Intensified:Suspicion of increased of ICP (not measured)",
      },
      {
        label: "Intensified:Increased ICP (documented)",
        value: "Intensified:Increased ICP (documented)",
      },
      {
        label: "Intensified:Clinical decision to target other mechanism",
        value: "Intensified:Clinical decision to target other mechanism",
      },
      {
        label: "Intensified:Change of doctor (different shift)",
        value: "Intensified:Change of doctor (different shift)",
      },
      {
        label: "Decreasing:Clinical improvement",
        value: "Decreasing:Clinical improvement",
      },
      {
        label: "Decreasing:Adequate control over ICP",
        value: "Decreasing:Adequate control over ICP",
      },
      {
        label: "Decreasing:Upper treatment limit reached/past",
        value: "Decreasing:Upper treatment limit reached/past",
      },
      {
        label: "Decreasing:Further treatment considered futile",
        value: "Decreasing:Further treatment considered futile",
      },
      {
        label: "Decreasing:Change of doctor (different shift)",
        value: "Decreasing:Change of doctor (different shift)",
      },
    ],
    conditions: "",
  },
  {
    id: "d(n)_til_summary",
    label: "Therapeutic Intensity Level 총점 (d(n)_til_summary)",
    type: "text",
    conditions: "",
  },

  // Daily Status 필드
  {
    id: "daily_status",
    label: "Daily Status",
    type: "radio",
    options: [
      { label: "Not completed", value: "Not completed" },
      { label: "In progress", value: "In progress" },
      { label: "Complete", value: "Complete" },
    ],
    conditions: "",
  },

  // Early Outcome 섹션을 위해 사용되는 필드들
  // TBI 의 경우에 나타나는 필드들
  {
    id: "tbi_delayedhematoma",
    label: "Delayed hematoma (tbi_delayedhematoma)",
    type: "radio",
    options: [
      { label: "No", value: "0" },
      { label: "Yes", value: "1" },
      { label: "Unknown", value: "Unknown" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd1_dt",
    label: "TBI neurologic deterioration 일시 (tbi_nd1_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd1",
    label: "TBI neurologic deterioration 여부 (tbi_nd1)",
    type: "radio",
    options: [
      { label: "Yes", value: "1" },
      { label: "No", value: "0" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd1_cause",
    label: "TBI neurologic deterioration 원인 (tbi_nd1_cause)",
    type: "radio",
    options: [
      { label: "Hematoma expansion", value: "1" },
      { label: "Cerebral edema", value: "2" },
      { label: "Hydrocephalus", value: "3" },
      { label: "Cerebral Infarction", value: "4" },
      { label: "Seizure", value: "5" },
      { label: "New cerebral hemorrhage", value: "6" },
      { label: "Medical complication (electro, sepsis...)", value: "7" },
      { label: "Others, specify", value: "99" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd1_cause_others",
    label: "TBI neurologic deterioration 원인_others (tbi_nd1_cause_others)",
    type: "text",
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd2_dt",
    label: "TBI neurologic deterioration 일시 (tbi_nd2_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd2",
    label: "TBI neurologic deterioration 여부 (tbi_nd2)",
    type: "radio",
    options: [
      { label: "Yes", value: "1" },
      { label: "No", value: "0" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd2_cause",
    label: "TBI neurologic deterioration 원인 (tbi_nd2_cause)",
    type: "radio",
    options: [
      { label: "Hematoma expansion", value: "1" },
      { label: "Cerebral edema", value: "2" },
      { label: "Hydrocephalus", value: "3" },
      { label: "Cerebral Infarction", value: "4" },
      { label: "Seizure", value: "5" },
      { label: "New cerebral hemorrhage", value: "6" },
      { label: "Medical complication (electro, sepsis...)", value: "7" },
      { label: "Others, specify", value: "99" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd2_cause_others",
    label: "TBI neurologic deterioration 원인_others (tbi_nd2_cause_others)",
    type: "text",
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd3_dt",
    label: "TBI neurologic deterioration 일시 (tbi_nd3_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd3",
    label: "TBI neurologic deterioration 여부 (tbi_nd3)",
    type: "radio",
    options: [
      { label: "Yes", value: "1" },
      { label: "No", value: "0" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd3_cause",
    label: "TBI neurologic deterioration 원인 (tbi_nd3_cause)",
    type: "radio",
    options: [
      { label: "Hematoma expansion", value: "1" },
      { label: "Cerebral edema", value: "2" },
      { label: "Hydrocephalus", value: "3" },
      { label: "Cerebral Infarction", value: "4" },
      { label: "Seizure", value: "5" },
      { label: "New cerebral hemorrhage", value: "6" },
      { label: "Medical complication (electro, sepsis...)", value: "7" },
      { label: "Others, specify", value: "99" },
    ],
    conditions: 'index_injury === "TBI"',
  },
  {
    id: "tbi_nd3_cause_others",
    label: "TBI neurologic deterioration 원인_others (tbi_nd3_cause_others)",
    type: "text",
    conditions: 'index_injury === "TBI"',
  },

  // SAH 의 경우에 나타나는 필드들

  {
    id: "sah_nd1",
    label: "SAH neurologic deterioration 여부 (sah_nd1)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd1_cause",
    label: "SAH neurologic deterioration 원인 (sah_nd1_cause)",
    type: "radio",
    options: [
      { label: "DCI(ischemia)", value: "DCI(ischemia)" },
      { label: "Hydrocephalus", value: "Hydrocephalus" },
      { label: "Rebleeding", value: "Rebleeding" },
      { label: "Infarction", value: "Infarction" },
      { label: "Seizure", value: "Seizure" },
      {
        label: "Intracranial complication (edema, iicp, ich, sdh...)",
        value: "Intracranial complication (edema, iicp, ich, sdh...)",
      },
      {
        label: "Systemic complication (electro, sepsis...)",
        value: "Systemic complication (electro, sepsis...)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd1_cause_others",
    label: "SAH neurologic deterioration 원인 (sah_nd1_cause_others)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd1_dt",
    label: "SAH neurologic deterioration 일시 (sah_nd1_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd2",
    label: "SAH neurologic deterioration 여부 (sah_nd2)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd2_cause",
    label: "SAH neurologic deterioration 원인 (sah_nd2_cause)",
    type: "radio",
    options: [
      { label: "DCI(ischemia)", value: "DCI(ischemia)" },
      { label: "Hydrocephalus", value: "Hydrocephalus" },
      { label: "Rebleeding", value: "Rebleeding" },
      { label: "Infarction", value: "Infarction" },
      { label: "Seizure", value: "Seizure" },
      {
        label: "Intracranial complication (edema, iicp, ich, sdh...)",
        value: "Intracranial complication (edema, iicp, ich, sdh...)",
      },
      {
        label: "Systemic complication (electro, sepsis...)",
        value: "Systemic complication (electro, sepsis...)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd2_cause_others",
    label: "SAH neurologic deterioration 원인 (sah_nd2_cause_others)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd2_dt",
    label: "SAH neurologic deterioration 일시 (sah_nd2_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd3",
    label: "SAH neurologic deterioration 여부 (sah_nd3)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd3_cause",
    label: "SAH neurologic deterioration 원인 (sah_nd3_cause)",
    type: "radio",
    options: [
      { label: "DCI(ischemia)", value: "DCI(ischemia)" },
      { label: "Hydrocephalus", value: "Hydrocephalus" },
      { label: "Rebleeding", value: "Rebleeding" },
      { label: "Infarction", value: "Infarction" },
      { label: "Seizure", value: "Seizure" },
      {
        label: "Intracranial complication (edema, iicp, ich, sdh...)",
        value: "Intracranial complication (edema, iicp, ich, sdh...)",
      },
      {
        label: "Systemic complication (electro, sepsis...)",
        value: "Systemic complication (electro, sepsis...)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd3_cause_others",
    label: "SAH neurologic deterioration 원인 (sah_nd3_cause_others)",
    type: "text",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_nd3_dt",
    label: "SAH neurologic deterioration 일시 (sah_nd3_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_dci",
    label: "SAH delayed cerebral ischemia 발생 여부 (sah_dci)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_dci_infarct",
    label:
      "Subarachnoid hemorrhage clinical deterioration infarction delayed cerebral ischemia indicator (sah_dci_infarct)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_angio_spasm",
    label: "Angiographic spasm 발생 여부 (sah_angio_spasm)",
    type: "radio",
    options: [
      { label: "None", value: "None" },
      { label: "DSA proven vasospasm", value: "DSA proven vasospasm" },
      {
        label: "Vasospasm suspected on CTA or MRA",
        value: "Vasospasm suspected on CTA or MRA",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_angio_spasm_symptom",
    label: "Symptomatic vasospasm 여부 (sah_angio_spasm_symptom)",
    type: "radio",
    options: [
      { label: "Asymptomatic", value: "Asymptomatic" },
      { label: "Symptomatic", value: "Symptomatic" },
      {
        label: "Unknown (Deep sedation 등)",
        value: "Unknown (Deep sedation 등)",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_angio_spasm_degree",
    label: "Vasospasm degree (sah_angio_spasm_degree)",
    type: "radio",
    options: [
      { label: "Mild", value: "Mild" },
      { label: "Moderate", value: "Moderate" },
      { label: "Severe", value: "Severe" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_angio_spasm_extent",
    label: "Vasospasm extent (sah_angio_spasm_extent)",
    type: "radio",
    options: [
      { label: "Focal", value: "Focal" },
      { label: "Diffuse", value: "Diffuse" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_tcd_spasm",
    label: "TCD spasm 발생 여부 (sah_tcd_spasm)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      {
        label: "Not performed or untestable",
        value: "Not performed or untestable",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_tcd_spasm_symptom",
    label: "TCD spasm의 symptomatic 여부 (sah_tcd_spasm_symptom)",
    type: "radio",
    options: [
      { label: "Asymptomatic", value: "Asymptomatic" },
      { label: "Symptomatic", value: "Symptomatic" },
      {
        label: "Unknown (Deep sedation 등)",
        value: "Unknown (Deep sedation 등)",
      },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_tcd_spasm_degree_mfv",
    label: "TCD spasm의 정도 (MFV 기준) (sah_tcd_spasm_degree_mfv)",
    type: "radio",
    options: [
      { label: "Mild", value: "Mild" },
      { label: "Moderate", value: "Moderate" },
      { label: "Severe", value: "Severe" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_tcd_spasm_degree_lr",
    label: "TCD spasm의 정도 (Lindegaard ratio 기준) (sah_tcd_spasm_degree_lr)",
    type: "radio",
    options: [
      { label: "Mild", value: "Mild" },
      { label: "Moderate", value: "Moderate" },
      { label: "Severe", value: "Severe" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_vasospasm_prophylaxis",
    label: "Vasospasm prophylaxis 여부 (sah_vasospasm_prophylaxis)",
    type: "checkbox",
    options: [
      { label: "PO nimodipine", value: "PO nimodipine" },
      { label: "IV nimodipine", value: "IV nimodipine" },
      { label: "IV milrinone", value: "IV milrinone" },
      { label: "IV MgSO4", value: "IV MgSO4" },
      { label: "No", value: "No" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_induced_htn_tx",
    label: "DCI or Vasospasm에 대한 Induced HTN 치료 여부 (sah_induced_htn_tx)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },
  {
    id: "sah_rescue_vasopasm_tx",
    label:
      "DCI or Vasospasm에 대한 rescue therapy 여부 (sah_rescue_vasopasm_tx)",
    type: "checkbox",
    options: [
      { label: "No", value: "No" },
      { label: "Endovascular - Chemical", value: "Endovascular - Chemical" },
      {
        label: "Endovascular - Mechanical",
        value: "Endovascular - Mechanical",
      },
      { label: "Intrathecal therapy", value: "Intrathecal therapy" },
    ],
    conditions: 'index_injury === "SAH (ruptured aneurysm)"',
  },

  //ICH 필드의 경우 (Early Outcome)

  {
    id: "ich_nd1",
    label: "ICH neurologic deterioration 여부 (ich_nd1)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd1_cause",
    label: "ICH neurologic deterioration 원인 (ich_nd1_cause)",
    type: "radio",
    options: [
      { label: "Hematoma expansion", value: "Hematoma expansion" },
      { label: "Perihematomal edema", value: "Perihematomal edema" },
      { label: "Hydrocephalus", value: "Hydrocephalus" },
      { label: "Cerebral infarction", value: "Cerebral infarction" },
      { label: "Seizure", value: "Seizure" },
      {
        label:
          "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
        value:
          "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd1_cause_others",
    label: "ICH neurologic deterioration 원인_others (ich_nd1_cause_others)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd1_dt",
    label: "ICH neurologic deterioration 일시 (ich_nd1_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd2",
    label: "ICH neurologic deterioration 여부 (ich_nd2)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd2_cause",
    label: "ICH neurologic deterioration 원인 (ich_nd2_cause)",
    type: "radio",
    options: [
      { label: "Hematoma expansion", value: "Hematoma expansion" },
      { label: "Perihematomal edema", value: "Perihematomal edema" },
      { label: "Hydrocephalus", value: "Hydrocephalus" },
      { label: "Cerebral infarction", value: "Cerebral infarction" },
      { label: "Seizure", value: "Seizure" },
      {
        label:
          "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
        value:
          "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd2_cause_others",
    label: "ICH neurologic deterioration 원인_others (ich_nd2_cause_others)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd2_dt",
    label: "ICH neurologic deterioration 일시 (ich_nd2_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd3",
    label: "ICH neurologic deterioration 여부 (ich_nd3)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd3_cause",
    label: "ICH neurologic deterioration 원인 (ich_nd3_cause)",
    type: "radio",
    options: [
      { label: "Hematoma expansion", value: "Hematoma expansion" },
      { label: "Perihematomal edema", value: "Perihematomal edema" },
      { label: "Hydrocephalus", value: "Hydrocephalus" },
      { label: "Cerebral infarction", value: "Cerebral infarction" },
      { label: "Seizure", value: "Seizure" },
      {
        label:
          "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
        value:
          "Medical complications (i.e. Sepsis, Fever, Metabolic encephalopathry)",
      },
      { label: "Others, specify", value: "Others, specify" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd3_cause_others",
    label: "ICH neurologic deterioration 원인_others (ich_nd3_cause_others)",
    type: "text",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_nd3_dt",
    label: "ICH neurologic deterioration 일시 (ich_nd3_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he1",
    label: "Hematoma expansion (ich_he1)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he1_action",
    label: "Hematoma expansion 발생 후 치료 (ich_he1_action)",
    type: "radio",
    options: [
      { label: "None", value: "None" },
      { label: "Medical therapy only", value: "Medical therapy only" },
      { label: "Any surgical therapy", value: "Any surgical therapy" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he1_dt",
    label: "Hematoma expansion 발생 일시 (ich_he1_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he2",
    label: "Hematoma expansion (ich_he2)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he2_action",
    label: "Hematoma expansion 발생 후 치료 (ich_he2_action)",
    type: "radio",
    options: [
      { label: "None", value: "None" },
      { label: "Medical therapy only", value: "Medical therapy only" },
      { label: "Any surgical therapy", value: "Any surgical therapy" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he2_dt",
    label: "Hematoma expansion 발생 일시 (ich_he2_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he3",
    label: "Hematoma expansion (ich_he3)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he3_action",
    label: "Hematoma expansion 발생 후 치료 (ich_he3_action)",
    type: "radio",
    options: [
      { label: "None", value: "None" },
      { label: "Medical therapy only", value: "Medical therapy only" },
      { label: "Any surgical therapy", value: "Any surgical therapy" },
    ],
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },
  {
    id: "ich_he3_dt",
    label: "Hematoma expansion 발생 일시 (ich_he3_dt)",
    type: "datetime-local",
    conditions: 'index_injury === "ICH (primary, secondary) / IVH"',
  },

  //Hosp Discharge

  {
    id: "dis_status",
    label: "퇴원시 사망 여부 (dis_status)",
    type: "radio",
    options: [
      { label: "Dead", value: "Dead" },
      { label: "Alive", value: "Alive" },
    ],
  },
  {
    id: "dis_to",
    label: "퇴원 장소 (dis_to)",
    type: "radio",
    options: [
      { label: "Home", value: "Home" },
      {
        label: "Transfer to other hospital",
        value: "Transfer to other hospital",
      },
      {
        label: "Transfer to other department",
        value: "Transfer to other department",
      },
      { label: "Expired", value: "Expired" },
    ],
  },
  {
    id: "dis_d",
    label: "퇴원 일자 (dis_d)",
    type: "date",
  },
  {
    id: "braindeath",
    label: "Brain death 여부 (braindeath)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
  },
  {
    id: "braindeath_d",
    label: "Brain death 판정 일시 (braindeath_d)",
    type: "date",
  },
  {
    id: "braindeath_organ",
    label: "장기공여여부 (braindeath_organ)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
  },
  {
    id: "polst_d",
    label: "POLST 일자 (polst_d)",
    type: "date",
  },
  {
    id: "polst",
    label: "POLST 여부 (polst)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
    ],
  },
  {
    id: "hosp_discharge_status",
    label: "Completion status_6",
    type: "radio",
    options: [
      { label: "Not started", value: "Not started" },
      { label: "In process", value: "In process" },
      { label: "Complete", value: "Complete" },
    ],
    defaultValue: "Not started",
  },

  //Surgery

  {
    id: "cranial_surg_done",
    label:
      "금번 입원 기간 (일반병실 포함) 중 cranial surgery 여부 (cranial_surg_done)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "cranial_surg_completion",
    label: "Form Completion Status (cranial_surg_completion)",
    type: "radio",
    options: [
      { label: "Not Started", value: "Not Started" },
      { label: "In Process", value: "In Process" },
      { label: "Complete", value: "Complete" },
      { label: "Queries Outstanding", value: "Queries Outstanding" },
      { label: "Not Performed", value: "Not Performed" },
    ],
  },
  {
    id: "extracranial_surg_done",
    label:
      "금번 입원 기간 (일반병실 포함) 중 extracranial surgery 여부 (extracranial_surg_done)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Unknown", value: "Unknown" },
    ],
  },
  {
    id: "cranial_surg1_start_dt",
    label: "Cranial surgery Start date/time (cranial_surg1_start_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg1_end_dt",
    label: "Cranial surgery End date/time (cranial_surg1_end_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg1_types",
    label: "Cranial surgery types (cranial_surg1_types)",
    type: "checkbox",
    options: [
      {
        label: "Decompressive Craniectomy",
        value: "Decompressive Craniectomy",
      },
      { label: "Craniotomy", value: "Craniotomy" },
      { label: "Burr-hole trephination", value: "Burr-hole trephination" },
      {
        label: "Minimally invasive surgery (cath)",
        value: "Minimally invasive surgery (cath)",
      },
      {
        label: "Minimally invasive surgery (endoscopic)",
        value: "Minimally invasive surgery (endoscopic)",
      },
      {
        label: "External ventricular drainage",
        value: "External ventricular drainage",
      },
      { label: "Intraventricular rt-PA", value: "Intraventricular rt-PA" },
      { label: "Intrahematomal rt-PA", value: "Intrahematomal rt-PA" },
      { label: "Bypass", value: "Bypass" },
      { label: "Clipping", value: "Clipping" },
      { label: "Trapping alone", value: "Trapping alone" },
      { label: "Wrapping", value: "Wrapping" },
      { label: "Hunterian ligation alone", value: "Hunterian ligation alone" },
      { label: "Coil", value: "Coil" },
      {
        label: "Coil with balloon remodeling",
        value: "Coil with balloon remodeling",
      },
      { label: "Stent only", value: "Stent only" },
      { label: "Stent/coil", value: "Stent/coil" },
      { label: "Vessel occlusion", value: "Vessel occlusion" },
      { label: "Flow diverter", value: "Flow diverter" },
      { label: "Lobectomy", value: "Lobectomy" },
      { label: "Evacuate SDH", value: "Evacuate SDH" },
      { label: "Evacuate EDH", value: "Evacuate EDH" },
      { label: "Evacuate ICH", value: "Evacuate ICH" },
      { label: "Abscess drainage", value: "Abscess drainage" },
      { label: "VP shunt programmable", value: "VP shunt programmable" },
      {
        label: "VP shunt Non-programmable",
        value: "VP shunt Non-programmable",
      },
      { label: "Shunt revision", value: "Shunt revision" },
      { label: "Cranioplasty", value: "Cranioplasty" },
      { label: "Brain debridement", value: "Brain debridement" },
      { label: "Others, specify", value: "Others@ specify" },
    ],
  },
  {
    id: "Cranial_surg1_types_others",
    label: "Cranial_surg1_types_others",
    type: "text",
  },
  {
    id: "Cranial_surg1_reason",
    label: "Cranial_surg1_reason",
    type: "radio",
    options: [
      { label: "Emergency/Life saving", value: "Emergency/Life saving" },
      { label: "Clinical deterioration", value: "Clinical deterioration" },
      { label: "Mass effect on CT", value: "Mass effect on CT" },
      { label: "Radiological progression", value: "Radiological progression" },
      { label: "Suspicion of raised ICP", value: "Suspicion of raised ICP" },
      { label: "Guideline adherence", value: "Guideline adherence" },
      { label: "To prevent deterioration", value: "To prevent deterioration" },
      { label: "Others, specify", value: "Others, specify" },
    ],
  },
  {
    id: "Cranial_surg1_reason_others",
    label: "Cranial_surg1_reason_others",
    type: "text",
  },
  {
    id: "Cranial_surg1_delay",
    label: "Cranial_surg1_delay",
    type: "radio",
    options: [
      { label: "No delay", value: "No delay" },
      {
        label: "Transferral from other hospital",
        value: "Transferral from other hospital",
      },
      { label: "Haemodynamic instability", value: "Haemodynamic instability" },
      { label: "No OR available", value: "No OR available" },
      { label: "surgeon delayed", value: "surgeon delayed" },
      { label: "Consent delayed", value: "Consent delayed" },
      { label: "Other", value: "Other" },
    ],
  },
  {
    id: "Cranial_surg1_delay_others",
    label: "Cranial_surg1_delay_others",
    type: "text",
  },
  {
    id: "cranial_surg1_notes",
    label:
      "Notes or additional information about surgeries (cranial_surg1_notes)",
    type: "text",
  },
  {
    id: "cranial_surg2_start_dt",
    label: "Cranial surgery Start date/time (cranial_surg2_start_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg2_end_dt",
    label: "Cranial surgery End date/time (cranial_surg2_end_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg2_types",
    label: "Cranial surgery types (cranial_surg2_types)",
    type: "checkbox",
    options: [
      {
        label: "Decompressive Craniectomy",
        value: "Decompressive Craniectomy",
      },
      { label: "Craniotomy", value: "Craniotomy" },
      { label: "Burr-hole trephination", value: "Burr-hole trephination" },
      {
        label: "Minimally invasive surgery (cath)",
        value: "Minimally invasive surgery (cath)",
      },
      {
        label: "Minimally invasive surgery (endoscopic)",
        value: "Minimally invasive surgery (endoscopic)",
      },
      {
        label: "External ventricular drainage",
        value: "External ventricular drainage",
      },
      { label: "Intraventricular rt-PA", value: "Intraventricular rt-PA" },
      { label: "Intrahematomal rt-PA", value: "Intrahematomal rt-PA" },
      { label: "Bypass", value: "Bypass" },
      { label: "Clipping", value: "Clipping" },
      { label: "Trapping alone", value: "Trapping alone" },
      { label: "Wrapping", value: "Wrapping" },
      { label: "Hunterian ligation alone", value: "Hunterian ligation alone" },
      { label: "Coil", value: "Coil" },
      {
        label: "Coil with balloon remodeling",
        value: "Coil with balloon remodeling",
      },
      { label: "Stent only", value: "Stent only" },
      { label: "Stent/coil", value: "Stent/coil" },
      { label: "Vessel occlusion", value: "Vessel occlusion" },
      { label: "Flow diverter", value: "Flow diverter" },
      { label: "Lobectomy", value: "Lobectomy" },
      { label: "Evacuate SDH", value: "Evacuate SDH" },
      { label: "Evacuate EDH", value: "Evacuate EDH" },
      { label: "Evacuate ICH", value: "Evacuate ICH" },
      { label: "Abscess drainage", value: "Abscess drainage" },
      { label: "VP shunt programmable", value: "VP shunt programmable" },
      {
        label: "VP shunt Non-programmable",
        value: "VP shunt Non-programmable",
      },
      { label: "Shunt revision", value: "Shunt revision" },
      { label: "Cranioplasty", value: "Cranioplasty" },
      { label: "Brain debridement", value: "Brain debridement" },
      { label: "Others, specify", value: "Others@ specify" },
    ],
  },
  {
    id: "Cranial_surg2_types_others",
    label: "Cranial_surg2_types_others",
    type: "text",
  },
  {
    id: "Cranial_surg2_reason",
    label: "Cranial_surg2_reason",
    type: "radio",
    options: [
      { label: "Emergency/Life saving", value: "Emergency/Life saving" },
      { label: "Clinical deterioration", value: "Clinical deterioration" },
      { label: "Mass effect on CT", value: "Mass effect on CT" },
      { label: "Radiological progression", value: "Radiological progression" },
      { label: "Suspicion of raised ICP", value: "Suspicion of raised ICP" },
      { label: "Guideline adherence", value: "Guideline adherence" },
      { label: "To prevent deterioration", value: "To prevent deterioration" },
      { label: "Others, specify", value: "Others, specify" },
    ],
  },
  {
    id: "Cranial_surg2_reason_others",
    label: "Cranial_surg2_reason_others",
    type: "text",
  },
  {
    id: "Cranial_surg2_delay",
    label: "Cranial_surg2_delay",
    type: "radio",
    options: [
      { label: "No delay", value: "No delay" },
      {
        label: "Transferral from other hospital",
        value: "Transferral from other hospital",
      },
      { label: "Haemodynamic instability", value: "Haemodynamic instability" },
      { label: "No OR available", value: "No OR available" },
      { label: "surgeon delayed", value: "surgeon delayed" },
      { label: "Consent delayed", value: "Consent delayed" },
      { label: "Other", value: "Other" },
    ],
  },
  {
    id: "Cranial_surg2_delay_others",
    label: "Cranial_surg2_delay_others",
    type: "text",
  },
  {
    id: "cranial_surg2_notes",
    label:
      "Notes or additional information about surgeries (cranial_surg2_notes)",
    type: "text",
  },
  {
    id: "cranial_surg3_start_dt",
    label: "Cranial surgery Start date/time (cranial_surg3_start_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg3_end_dt",
    label: "Cranial surgery End date/time (cranial_surg3_end_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg3_types",
    label: "Cranial surgery types (cranial_surg3_types)",
    type: "checkbox",
    options: [
      {
        label: "Decompressive Craniectomy",
        value: "Decompressive Craniectomy",
      },
      { label: "Craniotomy", value: "Craniotomy" },
      { label: "Burr-hole trephination", value: "Burr-hole trephination" },
      {
        label: "Minimally invasive surgery (cath)",
        value: "Minimally invasive surgery (cath)",
      },
      {
        label: "Minimally invasive surgery (endoscopic)",
        value: "Minimally invasive surgery (endoscopic)",
      },
      {
        label: "External ventricular drainage",
        value: "External ventricular drainage",
      },
      { label: "Intraventricular rt-PA", value: "Intraventricular rt-PA" },
      { label: "Intrahematomal rt-PA", value: "Intrahematomal rt-PA" },
      { label: "Bypass", value: "Bypass" },
      { label: "Clipping", value: "Clipping" },
      { label: "Trapping alone", value: "Trapping alone" },
      { label: "Wrapping", value: "Wrapping" },
      { label: "Hunterian ligation alone", value: "Hunterian ligation alone" },
      { label: "Coil", value: "Coil" },
      {
        label: "Coil with balloon remodeling",
        value: "Coil with balloon remodeling",
      },
      { label: "Stent only", value: "Stent only" },
      { label: "Stent/coil", value: "Stent/coil" },
      { label: "Vessel occlusion", value: "Vessel occlusion" },
      { label: "Flow diverter", value: "Flow diverter" },
      { label: "Lobectomy", value: "Lobectomy" },
      { label: "Evacuate SDH", value: "Evacuate SDH" },
      { label: "Evacuate EDH", value: "Evacuate EDH" },
      { label: "Evacuate ICH", value: "Evacuate ICH" },
      { label: "Abscess drainage", value: "Abscess drainage" },
      { label: "VP shunt programmable", value: "VP shunt programmable" },
      {
        label: "VP shunt Non-programmable",
        value: "VP shunt Non-programmable",
      },
      { label: "Shunt revision", value: "Shunt revision" },
      { label: "Cranioplasty", value: "Cranioplasty" },
      { label: "Brain debridement", value: "Brain debridement" },
      { label: "Others, specify", value: "Others@ specify" },
    ],
  },
  {
    id: "Cranial_surg3_types_others",
    label: "Cranial_surg3_types_others",
    type: "text",
  },
  {
    id: "Cranial_surg3_reason",
    label: "Cranial_surg3_reason",
    type: "radio",
    options: [
      { label: "Emergency/Life saving", value: "Emergency/Life saving" },
      { label: "Clinical deterioration", value: "Clinical deterioration" },
      { label: "Mass effect on CT", value: "Mass effect on CT" },
      { label: "Radiological progression", value: "Radiological progression" },
      { label: "Suspicion of raised ICP", value: "Suspicion of raised ICP" },
      { label: "Guideline adherence", value: "Guideline adherence" },
      { label: "To prevent deterioration", value: "To prevent deterioration" },
      { label: "Others, specify", value: "Others, specify" },
    ],
  },
  {
    id: "Cranial_surg3_reason_others",
    label: "Cranial_surg3_reason_others",
    type: "text",
  },
  {
    id: "Cranial_surg3_delay",
    label: "Cranial_surg3_delay",
    type: "radio",
    options: [
      { label: "No delay", value: "No delay" },
      {
        label: "Transferral from other hospital",
        value: "Transferral from other hospital",
      },
      { label: "Haemodynamic instability", value: "Haemodynamic instability" },
      { label: "No OR available", value: "No OR available" },
      { label: "surgeon delayed", value: "surgeon delayed" },
      { label: "Consent delayed", value: "Consent delayed" },
      { label: "Other", value: "Other" },
    ],
  },
  {
    id: "Cranial_surg3_delay_others",
    label: "Cranial_surg3_delay_others",
    type: "text",
  },
  {
    id: "cranial_surg3_notes",
    label:
      "Notes or additional information about surgeries (cranial_surg3_notes)",
    type: "text",
  },
  {
    id: "cranial_surg4_start_dt",
    label: "Cranial surgery Start date/time (cranial_surg4_start_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg4_end_dt",
    label: "Cranial surgery End date/time (cranial_surg4_end_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg4_types",
    label: "Cranial surgery types (cranial_surg4_types)",
    type: "checkbox",
    options: [
      {
        label: "Decompressive Craniectomy",
        value: "Decompressive Craniectomy",
      },
      { label: "Craniotomy", value: "Craniotomy" },
      { label: "Burr-hole trephination", value: "Burr-hole trephination" },
      {
        label: "Minimally invasive surgery (cath)",
        value: "Minimally invasive surgery (cath)",
      },
      {
        label: "Minimally invasive surgery (endoscopic)",
        value: "Minimally invasive surgery (endoscopic)",
      },
      {
        label: "External ventricular drainage",
        value: "External ventricular drainage",
      },
      { label: "Intraventricular rt-PA", value: "Intraventricular rt-PA" },
      { label: "Intrahematomal rt-PA", value: "Intrahematomal rt-PA" },
      { label: "Bypass", value: "Bypass" },
      { label: "Clipping", value: "Clipping" },
      { label: "Trapping alone", value: "Trapping alone" },
      { label: "Wrapping", value: "Wrapping" },
      { label: "Hunterian ligation alone", value: "Hunterian ligation alone" },
      { label: "Coil", value: "Coil" },
      {
        label: "Coil with balloon remodeling",
        value: "Coil with balloon remodeling",
      },
      { label: "Stent only", value: "Stent only" },
      { label: "Stent/coil", value: "Stent/coil" },
      { label: "Vessel occlusion", value: "Vessel occlusion" },
      { label: "Flow diverter", value: "Flow diverter" },
      { label: "Lobectomy", value: "Lobectomy" },
      { label: "Evacuate SDH", value: "Evacuate SDH" },
      { label: "Evacuate EDH", value: "Evacuate EDH" },
      { label: "Evacuate ICH", value: "Evacuate ICH" },
      { label: "Abscess drainage", value: "Abscess drainage" },
      { label: "VP shunt programmable", value: "VP shunt programmable" },
      {
        label: "VP shunt Non-programmable",
        value: "VP shunt Non-programmable",
      },
      { label: "Shunt revision", value: "Shunt revision" },
      { label: "Cranioplasty", value: "Cranioplasty" },
      { label: "Brain debridement", value: "Brain debridement" },
      { label: "Others, specify", value: "Others@ specify" },
    ],
  },
  {
    id: "Cranial_surg4_types_others",
    label: "Cranial_surg4_types_others",
    type: "text",
  },
  {
    id: "Cranial_surg4_reason",
    label: "Cranial_surg4_reason",
    type: "radio",
    options: [
      { label: "Emergency/Life saving", value: "Emergency/Life saving" },
      { label: "Clinical deterioration", value: "Clinical deterioration" },
      { label: "Mass effect on CT", value: "Mass effect on CT" },
      { label: "Radiological progression", value: "Radiological progression" },
      { label: "Suspicion of raised ICP", value: "Suspicion of raised ICP" },
      { label: "Guideline adherence", value: "Guideline adherence" },
      { label: "To prevent deterioration", value: "To prevent deterioration" },
      { label: "Others, specify", value: "Others, specify" },
    ],
  },
  {
    id: "Cranial_surg4_reason_others",
    label: "Cranial_surg4_reason_others",
    type: "text",
  },
  {
    id: "Cranial_surg4_delay",
    label: "Cranial_surg4_delay",
    type: "radio",
    options: [
      { label: "No delay", value: "No delay" },
      {
        label: "Transferral from other hospital",
        value: "Transferral from other hospital",
      },
      { label: "Haemodynamic instability", value: "Haemodynamic instability" },
      { label: "No OR available", value: "No OR available" },
      { label: "surgeon delayed", value: "surgeon delayed" },
      { label: "Consent delayed", value: "Consent delayed" },
      { label: "Other", value: "Other" },
    ],
  },
  {
    id: "Cranial_surg4_delay_others",
    label: "Cranial_surg4_delay_others",
    type: "text",
  },
  {
    id: "cranial_surg4_notes",
    label:
      "Notes or additional information about surgeries (cranial_surg4_notes)",
    type: "text",
  },
  {
    id: "cranial_surg5_start_dt",
    label: "Cranial surgery Start date/time (cranial_surg5_start_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg5_end_dt",
    label: "Cranial surgery End date/time (cranial_surg5_end_dt)",
    type: "datetime-local",
  },
  {
    id: "cranial_surg5_types",
    label: "Cranial surgery types (cranial_surg5_types)",
    type: "checkbox",
    options: [
      {
        label: "Decompressive Craniectomy",
        value: "Decompressive Craniectomy",
      },
      { label: "Craniotomy", value: "Craniotomy" },
      { label: "Burr-hole trephination", value: "Burr-hole trephination" },
      {
        label: "Minimally invasive surgery (cath)",
        value: "Minimally invasive surgery (cath)",
      },
      {
        label: "Minimally invasive surgery (endoscopic)",
        value: "Minimally invasive surgery (endoscopic)",
      },
      {
        label: "External ventricular drainage",
        value: "External ventricular drainage",
      },
      { label: "Intraventricular rt-PA", value: "Intraventricular rt-PA" },
      { label: "Intrahematomal rt-PA", value: "Intrahematomal rt-PA" },
      { label: "Bypass", value: "Bypass" },
      { label: "Clipping", value: "Clipping" },
      { label: "Trapping alone", value: "Trapping alone" },
      { label: "Wrapping", value: "Wrapping" },
      { label: "Hunterian ligation alone", value: "Hunterian ligation alone" },
      { label: "Coil", value: "Coil" },
      {
        label: "Coil with balloon remodeling",
        value: "Coil with balloon remodeling",
      },
      { label: "Stent only", value: "Stent only" },
      { label: "Stent/coil", value: "Stent/coil" },
      { label: "Vessel occlusion", value: "Vessel occlusion" },
      { label: "Flow diverter", value: "Flow diverter" },
      { label: "Lobectomy", value: "Lobectomy" },
      { label: "Evacuate SDH", value: "Evacuate SDH" },
      { label: "Evacuate EDH", value: "Evacuate EDH" },
      { label: "Evacuate ICH", value: "Evacuate ICH" },
      { label: "Abscess drainage", value: "Abscess drainage" },
      { label: "VP shunt programmable", value: "VP shunt programmable" },
      {
        label: "VP shunt Non-programmable",
        value: "VP shunt Non-programmable",
      },
      { label: "Shunt revision", value: "Shunt revision" },
      { label: "Cranioplasty", value: "Cranioplasty" },
      { label: "Brain debridement", value: "Brain debridement" },
      { label: "Others, specify", value: "Others@ specify" },
    ],
  },
  {
    id: "Cranial_surg5_types_others",
    label: "Cranial_surg5_types_others",
    type: "text",
  },
  {
    id: "Cranial_surg5_reason",
    label: "Cranial_surg5_reason",
    type: "radio",
    options: [
      { label: "Emergency/Life saving", value: "Emergency/Life saving" },
      { label: "Clinical deterioration", value: "Clinical deterioration" },
      { label: "Mass effect on CT", value: "Mass effect on CT" },
      { label: "Radiological progression", value: "Radiological progression" },
      { label: "Suspicion of raised ICP", value: "Suspicion of raised ICP" },
      { label: "Guideline adherence", value: "Guideline adherence" },
      { label: "To prevent deterioration", value: "To prevent deterioration" },
      { label: "Others, specify", value: "Others, specify" },
    ],
  },
  {
    id: "Cranial_surg5_reason_others",
    label: "Cranial_surg5_reason_others",
    type: "text",
  },
  {
    id: "Cranial_surg5_delay",
    label: "Cranial_surg5_delay",
    type: "radio",
    options: [
      { label: "No delay", value: "No delay" },
      {
        label: "Transferral from other hospital",
        value: "Transferral from other hospital",
      },
      { label: "Haemodynamic instability", value: "Haemodynamic instability" },
      { label: "No OR available", value: "No OR available" },
      { label: "surgeon delayed", value: "surgeon delayed" },
      { label: "Consent delayed", value: "Consent delayed" },
      { label: "Other", value: "Other" },
    ],
  },
  {
    id: "Cranial_surg5_delay_others",
    label: "Cranial_surg5_delay_others",
    type: "text",
  },
  {
    id: "cranial_surg5_notes",
    label:
      "Notes or additional information about surgeries (cranial_surg5_notes)",
    type: "text",
  },
  {
    id: "surgeries_status",
    label: "Completion status_7",
    type: "radio",
    options: [
      { label: "Not started", value: "Not started" },
      { label: "In process", value: "In process" },
      { label: "Complete", value: "Complete" },
    ],
    defaultValue: "Not started",
  },

  //Outcome

  {
    id: "mrs_6m",
    label: "6개월 mRS (mrs_6m)",
    type: "radio",
    options: [
      { label: "0 : No symptoms", value: "0 : No symptoms" },
      {
        label:
          "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
        value:
          "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
      },
      {
        label:
          "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
        value:
          "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
      },
      {
        label:
          "3 : Moderate disability. Requires some help, but able to walk unassisted",
        value:
          "3 : Moderate disability. Requires some help, but able to walk unassisted",
      },
      {
        label:
          "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted",
        value:
          "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted",
      },
      {
        label:
          "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent",
        value:
          "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent",
      },
      { label: "6 : Dead", value: "6 : Dead" },
    ],
  },
  {
    id: "gose_6m",
    label: "6개월 GOSE 점수 (gose_6m)",
    type: "radio",
    options: [
      { label: "1 : Dead", value: "1 : Dead" },
      {
        label: "2 : Vegetative State (VS)",
        value: "2 : Vegetative State (VS)",
      },
      {
        label: "3 : Lower Severe Disability (Lower SD)",
        value: "3 : Lower Severe Disability (Lower SD)",
      },
      {
        label: "4 : Upper Severe Disability (Upper SD)",
        value: "4 : Upper Severe Disability (Upper SD)",
      },
      {
        label: "5 : Lower Moderate Disability (Lower MD)",
        value: "5 : Lower Moderate Disability (Lower MD)",
      },
      {
        label: "6 : Upper Moderate Disability (Upper MD)",
        value: "6 : Upper Moderate Disability (Upper MD)",
      },
      {
        label: "7 : Lower Good Recovery (Lower GR)",
        value: "7 : Lower Good Recovery (Lower GR)",
      },
      {
        label: "8 : Upper Good Recovery (Upper GR)",
        value: "8 : Upper Good Recovery (Upper GR)",
      },
    ],
  },
  {
    id: "fu_yn_6m",
    label: "6개 FU 여부",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Failed", value: "Failed" },
    ],
  },
  {
    id: "shunt_dependency_6m",
    label: "6개월 Shunt 수술 여부 (shunt_dependency_6m)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Previous shunt (+)", value: "Previous shunt (+)" },
    ],
  },
  {
    id: "fu_d_6m",
    label: "6개월 outcome FU 일자 (fu_d_6m)",
    type: "date",
  },
  {
    id: "mrs_12m",
    label: "1년 mRS (mrs_12m)",
    type: "radio",
    options: [
      { label: "0 : No symptoms", value: "0 : No symptoms" },
      {
        label:
          "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
        value:
          "1 : No significant disability. Able to carry out all usual activities, despite some symptoms",
      },
      {
        label:
          "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
        value:
          "2 : Slight disability. Able to look after own affairs without assistance, but unable to carry out all previous activities",
      },
      {
        label:
          "3 : Moderate disability. Requires some help, but able to walk unassisted",
        value:
          "3 : Moderate disability. Requires some help, but able to walk unassisted",
      },
      {
        label:
          "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted",
        value:
          "4 : Moderately severe disability. Unable to attend to own bodily needs without assistance, and unable to walk unassisted",
      },
      {
        label:
          "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent",
        value:
          "5 : Severe disability. Requires constant nursing care and attention, bedridden, incontinent",
      },
      { label: "6 : Dead", value: "6 : Dead" },
    ],
  },
  {
    id: "gose_12m",
    label: "1년 GOSE 점수 (gose_12m)",
    type: "radio",
    options: [
      { label: "1 : Dead", value: "1 : Dead" },
      {
        label: "2 : Vegetative State (VS)",
        value: "2 : Vegetative State (VS)",
      },
      {
        label: "3 : Lower Severe Disability (Lower SD)",
        value: "3 : Lower Severe Disability (Lower SD)",
      },
      {
        label: "4 : Upper Severe Disability (Upper SD)",
        value: "4 : Upper Severe Disability (Upper SD)",
      },
      {
        label: "5 : Lower Moderate Disability (Lower MD)",
        value: "5 : Lower Moderate Disability (Lower MD)",
      },
      {
        label: "6 : Upper Moderate Disability (Upper MD)",
        value: "6 : Upper Moderate Disability (Upper MD)",
      },
      {
        label: "7 : Lower Good Recovery (Lower GR)",
        value: "7 : Lower Good Recovery (Lower GR)",
      },
      {
        label: "8 : Upper Good Recovery (Upper GR)",
        value: "8 : Upper Good Recovery (Upper GR)",
      },
    ],
  },
  {
    id: "fu_yn_12m",
    label: "12개원 FU 여부",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Failed", value: "Failed" },
    ],
  },
  {
    id: "shunt_dependency_12m",
    label: "1년 Shunt 수술 여부 (shunt_dependency_12m)",
    type: "radio",
    options: [
      { label: "No", value: "No" },
      { label: "Yes", value: "Yes" },
      { label: "Previous shunt (+)", value: "Previous shunt (+)" },
    ],
  },
  {
    id: "fu_d_12m",
    label: "1년 outcome FU 일자 (fu_d_12m)",
    type: "date",
  },
  {
    id: "Final_status",
    label: "Final Completion status",
    type: "radio",
    options: [
      { label: "Not started", value: "Not started" },
      { label: "In process", value: "In process" },
      { label: "Complete", value: "Complete" },
    ],
    defaultValue: "Not started",
  },
];

/* ── 파생 데이터 (기존 코드 호환) ─────────────────────────────── */
export const formFieldMap = Object.fromEntries(
  formFieldDefs.map((f) => [f.id, f])
);
